/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../services/api/API.service";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createClient = /* GraphQL */ `mutation CreateClient(
  $input: CreateClientInput!
  $condition: ModelClientConditionInput
) {
  createClient(input: $input, condition: $condition) {
    id
    status
    business_name
    comertial_name
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    biography
    plan
    fee
    increment
    mercadoFee
    mercadoIncrement
    popFee
    popIncrement
    printedFee
    printedIncrement
    users
    restrictedUsers
    nonRestrictedUsers
    regions
    providers
    popProviders
    printedProviders
    logisticFrequency
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    administrators {
      id
      name
      email
      phoneNumber
      __typename
    }
    signDocument {
      url
      enabled
      __typename
    }
    legal_representative
    legal_representative_email
    legal_representative_address
    tcdUsers
    billingUsers {
      id
      name
      email
      phoneNumber
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateClientMutationVariables,
  APITypes.CreateClientMutation
>;
export const updateClient = /* GraphQL */ `mutation UpdateClient(
  $input: UpdateClientInput!
  $condition: ModelClientConditionInput
) {
  updateClient(input: $input, condition: $condition) {
    id
    status
    business_name
    comertial_name
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    biography
    plan
    fee
    increment
    mercadoFee
    mercadoIncrement
    popFee
    popIncrement
    printedFee
    printedIncrement
    users
    restrictedUsers
    nonRestrictedUsers
    regions
    providers
    popProviders
    printedProviders
    logisticFrequency
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    administrators {
      id
      name
      email
      phoneNumber
      __typename
    }
    signDocument {
      url
      enabled
      __typename
    }
    legal_representative
    legal_representative_email
    legal_representative_address
    tcdUsers
    billingUsers {
      id
      name
      email
      phoneNumber
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClientMutationVariables,
  APITypes.UpdateClientMutation
>;
export const deleteClient = /* GraphQL */ `mutation DeleteClient(
  $input: DeleteClientInput!
  $condition: ModelClientConditionInput
) {
  deleteClient(input: $input, condition: $condition) {
    id
    status
    business_name
    comertial_name
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    biography
    plan
    fee
    increment
    mercadoFee
    mercadoIncrement
    popFee
    popIncrement
    printedFee
    printedIncrement
    users
    restrictedUsers
    nonRestrictedUsers
    regions
    providers
    popProviders
    printedProviders
    logisticFrequency
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    administrators {
      id
      name
      email
      phoneNumber
      __typename
    }
    signDocument {
      url
      enabled
      __typename
    }
    legal_representative
    legal_representative_email
    legal_representative_address
    tcdUsers
    billingUsers {
      id
      name
      email
      phoneNumber
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteClientMutationVariables,
  APITypes.DeleteClientMutation
>;
export const createClientSetting = /* GraphQL */ `mutation CreateClientSetting(
  $input: CreateClientSettingInput!
  $condition: ModelClientSettingConditionInput
) {
  createClientSetting(input: $input, condition: $condition) {
    id
    crmJiraId
    orderBudget
    domain
    filterColors
    primaryColors
    accentColors
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateClientSettingMutationVariables,
  APITypes.CreateClientSettingMutation
>;
export const updateClientSetting = /* GraphQL */ `mutation UpdateClientSetting(
  $input: UpdateClientSettingInput!
  $condition: ModelClientSettingConditionInput
) {
  updateClientSetting(input: $input, condition: $condition) {
    id
    crmJiraId
    orderBudget
    domain
    filterColors
    primaryColors
    accentColors
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClientSettingMutationVariables,
  APITypes.UpdateClientSettingMutation
>;
export const deleteClientSetting = /* GraphQL */ `mutation DeleteClientSetting(
  $input: DeleteClientSettingInput!
  $condition: ModelClientSettingConditionInput
) {
  deleteClientSetting(input: $input, condition: $condition) {
    id
    crmJiraId
    orderBudget
    domain
    filterColors
    primaryColors
    accentColors
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteClientSettingMutationVariables,
  APITypes.DeleteClientSettingMutation
>;
export const createClientOption = /* GraphQL */ `mutation CreateClientOption(
  $input: CreateClientOptionInput!
  $condition: ModelClientOptionConditionInput
) {
  createClientOption(input: $input, condition: $condition) {
    id
    pakmail
    orderVat
    hasMercado
    hasAmazon
    hasAutomobiles
    publicDashboards
    printPrices
    logisticPrices
    hidePricesAndFlow
    showPhones
    fullCoupaDescriptions
    isPremium
    isPop
    isPrinted
    allPremiumRfqs
    allPopRfqs
    allPrintedRfqs
    autoUpdateHomePage
    showVat
    requiredDeliveryInfo
    restrictedCatalogue
    excludeCoupa
    tcdPayment
    automaticLogisticGuides
    transferencePayment
    customCatalogue
    disableProjectDescriptions
    showBranding
    customCostCenter
    couponsEnabled
    showChat
    hasCrmSync
    onlyQuotes
    autoSaveDeliveryInfo
    limitMaxRequestOnDiscounts
    freeLocalShipping
    discountShipping
    printingBreakdown
    skipAlendum
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateClientOptionMutationVariables,
  APITypes.CreateClientOptionMutation
>;
export const updateClientOption = /* GraphQL */ `mutation UpdateClientOption(
  $input: UpdateClientOptionInput!
  $condition: ModelClientOptionConditionInput
) {
  updateClientOption(input: $input, condition: $condition) {
    id
    pakmail
    orderVat
    hasMercado
    hasAmazon
    hasAutomobiles
    publicDashboards
    printPrices
    logisticPrices
    hidePricesAndFlow
    showPhones
    fullCoupaDescriptions
    isPremium
    isPop
    isPrinted
    allPremiumRfqs
    allPopRfqs
    allPrintedRfqs
    autoUpdateHomePage
    showVat
    requiredDeliveryInfo
    restrictedCatalogue
    excludeCoupa
    tcdPayment
    automaticLogisticGuides
    transferencePayment
    customCatalogue
    disableProjectDescriptions
    showBranding
    customCostCenter
    couponsEnabled
    showChat
    hasCrmSync
    onlyQuotes
    autoSaveDeliveryInfo
    limitMaxRequestOnDiscounts
    freeLocalShipping
    discountShipping
    printingBreakdown
    skipAlendum
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClientOptionMutationVariables,
  APITypes.UpdateClientOptionMutation
>;
export const deleteClientOption = /* GraphQL */ `mutation DeleteClientOption(
  $input: DeleteClientOptionInput!
  $condition: ModelClientOptionConditionInput
) {
  deleteClientOption(input: $input, condition: $condition) {
    id
    pakmail
    orderVat
    hasMercado
    hasAmazon
    hasAutomobiles
    publicDashboards
    printPrices
    logisticPrices
    hidePricesAndFlow
    showPhones
    fullCoupaDescriptions
    isPremium
    isPop
    isPrinted
    allPremiumRfqs
    allPopRfqs
    allPrintedRfqs
    autoUpdateHomePage
    showVat
    requiredDeliveryInfo
    restrictedCatalogue
    excludeCoupa
    tcdPayment
    automaticLogisticGuides
    transferencePayment
    customCatalogue
    disableProjectDescriptions
    showBranding
    customCostCenter
    couponsEnabled
    showChat
    hasCrmSync
    onlyQuotes
    autoSaveDeliveryInfo
    limitMaxRequestOnDiscounts
    freeLocalShipping
    discountShipping
    printingBreakdown
    skipAlendum
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteClientOptionMutationVariables,
  APITypes.DeleteClientOptionMutation
>;
export const createProvider = /* GraphQL */ `mutation CreateProvider(
  $input: CreateProviderInput!
  $condition: ModelProviderConditionInput
) {
  createProvider(input: $input, condition: $condition) {
    id
    isApproved
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comertial_name
    bussiness_name {
      tax_residence {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      rfc
      name
      __typename
    }
    idProcter
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    biography
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    experience
    pros
    cons
    cte_rating {
      name
      rating
      __typename
    }
    shopping_rating {
      name
      rating
      __typename
    }
    video
    tags
    money_filter_c
    money_filter_d
    users
    bank
    account
    clabe
    cuenta_correo
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    isProvider
    sameAddress
    isPop
    isPrinted
    hasLogistic
    created
    updated
    addFiles {
      key
      url
      sign
      status
      __typename
    }
    signFiles {
      key
      url
      sign
      status
      __typename
    }
    representante_legal
    escritura_constitucion
    notario_a
    constituido_down_edo
    rrpp
    isPremium
    isTrustProvider
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProviderMutationVariables,
  APITypes.CreateProviderMutation
>;
export const updateProvider = /* GraphQL */ `mutation UpdateProvider(
  $input: UpdateProviderInput!
  $condition: ModelProviderConditionInput
) {
  updateProvider(input: $input, condition: $condition) {
    id
    isApproved
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comertial_name
    bussiness_name {
      tax_residence {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      rfc
      name
      __typename
    }
    idProcter
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    biography
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    experience
    pros
    cons
    cte_rating {
      name
      rating
      __typename
    }
    shopping_rating {
      name
      rating
      __typename
    }
    video
    tags
    money_filter_c
    money_filter_d
    users
    bank
    account
    clabe
    cuenta_correo
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    isProvider
    sameAddress
    isPop
    isPrinted
    hasLogistic
    created
    updated
    addFiles {
      key
      url
      sign
      status
      __typename
    }
    signFiles {
      key
      url
      sign
      status
      __typename
    }
    representante_legal
    escritura_constitucion
    notario_a
    constituido_down_edo
    rrpp
    isPremium
    isTrustProvider
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProviderMutationVariables,
  APITypes.UpdateProviderMutation
>;
export const deleteProvider = /* GraphQL */ `mutation DeleteProvider(
  $input: DeleteProviderInput!
  $condition: ModelProviderConditionInput
) {
  deleteProvider(input: $input, condition: $condition) {
    id
    isApproved
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comertial_name
    bussiness_name {
      tax_residence {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      rfc
      name
      __typename
    }
    idProcter
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    biography
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    experience
    pros
    cons
    cte_rating {
      name
      rating
      __typename
    }
    shopping_rating {
      name
      rating
      __typename
    }
    video
    tags
    money_filter_c
    money_filter_d
    users
    bank
    account
    clabe
    cuenta_correo
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    isProvider
    sameAddress
    isPop
    isPrinted
    hasLogistic
    created
    updated
    addFiles {
      key
      url
      sign
      status
      __typename
    }
    signFiles {
      key
      url
      sign
      status
      __typename
    }
    representante_legal
    escritura_constitucion
    notario_a
    constituido_down_edo
    rrpp
    isPremium
    isTrustProvider
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProviderMutationVariables,
  APITypes.DeleteProviderMutation
>;
export const createProviderSetting = /* GraphQL */ `mutation CreateProviderSetting(
  $input: CreateProviderSettingInput!
  $condition: ModelProviderSettingConditionInput
) {
  createProviderSetting(input: $input, condition: $condition) {
    id
    primaryColors
    accentColors
    categories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProviderSettingMutationVariables,
  APITypes.CreateProviderSettingMutation
>;
export const updateProviderSetting = /* GraphQL */ `mutation UpdateProviderSetting(
  $input: UpdateProviderSettingInput!
  $condition: ModelProviderSettingConditionInput
) {
  updateProviderSetting(input: $input, condition: $condition) {
    id
    primaryColors
    accentColors
    categories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProviderSettingMutationVariables,
  APITypes.UpdateProviderSettingMutation
>;
export const deleteProviderSetting = /* GraphQL */ `mutation DeleteProviderSetting(
  $input: DeleteProviderSettingInput!
  $condition: ModelProviderSettingConditionInput
) {
  deleteProviderSetting(input: $input, condition: $condition) {
    id
    primaryColors
    accentColors
    categories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProviderSettingMutationVariables,
  APITypes.DeleteProviderSettingMutation
>;
export const createProviderFile = /* GraphQL */ `mutation CreateProviderFile(
  $input: CreateProviderFileInput!
  $condition: ModelProviderFileConditionInput
) {
  createProviderFile(input: $input, condition: $condition) {
    id
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProviderFileMutationVariables,
  APITypes.CreateProviderFileMutation
>;
export const updateProviderFile = /* GraphQL */ `mutation UpdateProviderFile(
  $input: UpdateProviderFileInput!
  $condition: ModelProviderFileConditionInput
) {
  updateProviderFile(input: $input, condition: $condition) {
    id
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProviderFileMutationVariables,
  APITypes.UpdateProviderFileMutation
>;
export const deleteProviderFile = /* GraphQL */ `mutation DeleteProviderFile(
  $input: DeleteProviderFileInput!
  $condition: ModelProviderFileConditionInput
) {
  deleteProviderFile(input: $input, condition: $condition) {
    id
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProviderFileMutationVariables,
  APITypes.DeleteProviderFileMutation
>;
export const createColors = /* GraphQL */ `mutation CreateColors(
  $input: CreateColorsInput!
  $condition: ModelColorsConditionInput
) {
  createColors(input: $input, condition: $condition) {
    id
    status
    name
    rgb
    hex
    position
    variantNames
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateColorsMutationVariables,
  APITypes.CreateColorsMutation
>;
export const updateColors = /* GraphQL */ `mutation UpdateColors(
  $input: UpdateColorsInput!
  $condition: ModelColorsConditionInput
) {
  updateColors(input: $input, condition: $condition) {
    id
    status
    name
    rgb
    hex
    position
    variantNames
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateColorsMutationVariables,
  APITypes.UpdateColorsMutation
>;
export const deleteColors = /* GraphQL */ `mutation DeleteColors(
  $input: DeleteColorsInput!
  $condition: ModelColorsConditionInput
) {
  deleteColors(input: $input, condition: $condition) {
    id
    status
    name
    rgb
    hex
    position
    variantNames
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteColorsMutationVariables,
  APITypes.DeleteColorsMutation
>;
export const createHomePageCarouselBanner = /* GraphQL */ `mutation CreateHomePageCarouselBanner(
  $input: CreateHomePageCarouselBannerInput!
  $condition: ModelHomePageCarouselBannerConditionInput
) {
  createHomePageCarouselBanner(input: $input, condition: $condition) {
    id
    status
    isPublic
    title
    subtitle
    copy
    path
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    position
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHomePageCarouselBannerMutationVariables,
  APITypes.CreateHomePageCarouselBannerMutation
>;
export const updateHomePageCarouselBanner = /* GraphQL */ `mutation UpdateHomePageCarouselBanner(
  $input: UpdateHomePageCarouselBannerInput!
  $condition: ModelHomePageCarouselBannerConditionInput
) {
  updateHomePageCarouselBanner(input: $input, condition: $condition) {
    id
    status
    isPublic
    title
    subtitle
    copy
    path
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    position
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHomePageCarouselBannerMutationVariables,
  APITypes.UpdateHomePageCarouselBannerMutation
>;
export const deleteHomePageCarouselBanner = /* GraphQL */ `mutation DeleteHomePageCarouselBanner(
  $input: DeleteHomePageCarouselBannerInput!
  $condition: ModelHomePageCarouselBannerConditionInput
) {
  deleteHomePageCarouselBanner(input: $input, condition: $condition) {
    id
    status
    isPublic
    title
    subtitle
    copy
    path
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    position
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHomePageCarouselBannerMutationVariables,
  APITypes.DeleteHomePageCarouselBannerMutation
>;
export const createHomePage = /* GraphQL */ `mutation CreateHomePage(
  $input: CreateHomePageInput!
  $condition: ModelHomePageConditionInput
) {
  createHomePage(input: $input, condition: $condition) {
    id
    status
    isPublic
    showArrow
    showNumeration
    icon
    title
    subtitle
    body
    route
    titlePosition
    textAlign
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    borderColor
    textColor
    position
    verticalLine
    browseButton
    visibleFor
    visibleForUserBrand
    hasLeftLine
    hasVisibleButton
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHomePageMutationVariables,
  APITypes.CreateHomePageMutation
>;
export const updateHomePage = /* GraphQL */ `mutation UpdateHomePage(
  $input: UpdateHomePageInput!
  $condition: ModelHomePageConditionInput
) {
  updateHomePage(input: $input, condition: $condition) {
    id
    status
    isPublic
    showArrow
    showNumeration
    icon
    title
    subtitle
    body
    route
    titlePosition
    textAlign
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    borderColor
    textColor
    position
    verticalLine
    browseButton
    visibleFor
    visibleForUserBrand
    hasLeftLine
    hasVisibleButton
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHomePageMutationVariables,
  APITypes.UpdateHomePageMutation
>;
export const deleteHomePage = /* GraphQL */ `mutation DeleteHomePage(
  $input: DeleteHomePageInput!
  $condition: ModelHomePageConditionInput
) {
  deleteHomePage(input: $input, condition: $condition) {
    id
    status
    isPublic
    showArrow
    showNumeration
    icon
    title
    subtitle
    body
    route
    titlePosition
    textAlign
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    borderColor
    textColor
    position
    verticalLine
    browseButton
    visibleFor
    visibleForUserBrand
    hasLeftLine
    hasVisibleButton
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHomePageMutationVariables,
  APITypes.DeleteHomePageMutation
>;
export const createHomePageBottomBanner = /* GraphQL */ `mutation CreateHomePageBottomBanner(
  $input: CreateHomePageBottomBannerInput!
  $condition: ModelHomePageBottomBannerConditionInput
) {
  createHomePageBottomBanner(input: $input, condition: $condition) {
    id
    status
    isPublic
    title
    subtitle
    icon
    route
    showArrow
    bannerImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHomePageBottomBannerMutationVariables,
  APITypes.CreateHomePageBottomBannerMutation
>;
export const updateHomePageBottomBanner = /* GraphQL */ `mutation UpdateHomePageBottomBanner(
  $input: UpdateHomePageBottomBannerInput!
  $condition: ModelHomePageBottomBannerConditionInput
) {
  updateHomePageBottomBanner(input: $input, condition: $condition) {
    id
    status
    isPublic
    title
    subtitle
    icon
    route
    showArrow
    bannerImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHomePageBottomBannerMutationVariables,
  APITypes.UpdateHomePageBottomBannerMutation
>;
export const deleteHomePageBottomBanner = /* GraphQL */ `mutation DeleteHomePageBottomBanner(
  $input: DeleteHomePageBottomBannerInput!
  $condition: ModelHomePageBottomBannerConditionInput
) {
  deleteHomePageBottomBanner(input: $input, condition: $condition) {
    id
    status
    isPublic
    title
    subtitle
    icon
    route
    showArrow
    bannerImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHomePageBottomBannerMutationVariables,
  APITypes.DeleteHomePageBottomBannerMutation
>;
export const createProducto = /* GraphQL */ `mutation CreateProducto(
  $input: CreateProductoInput!
  $condition: ModelProductoConditionInput
) {
  createProducto(input: $input, condition: $condition) {
    id
    providerId
    categoryId
    name
    status
    bestSeller
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    order
    sku
    brand
    colors
    pgClasitication
    delivery_time
    delivery_time_units
    stock
    minRequest
    maxRequest
    article_of_clothing
    size
    price
    long_description
    short_description
    creator
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    isExternal
    isAllowable
    isRestricted
    isAutoSkipped
    isAutoAllowed
    isPurse
    massiveLayout
    hasBaseAmmount
    isFreeAmmount
    isCard
    isByRequest
    isMultiPrice
    cardBaseAmmount
    minCardBaseAmmount
    maxCardBaseAmmount
    nameExternal
    unspsc
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductoMutationVariables,
  APITypes.CreateProductoMutation
>;
export const updateProducto = /* GraphQL */ `mutation UpdateProducto(
  $input: UpdateProductoInput!
  $condition: ModelProductoConditionInput
) {
  updateProducto(input: $input, condition: $condition) {
    id
    providerId
    categoryId
    name
    status
    bestSeller
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    order
    sku
    brand
    colors
    pgClasitication
    delivery_time
    delivery_time_units
    stock
    minRequest
    maxRequest
    article_of_clothing
    size
    price
    long_description
    short_description
    creator
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    isExternal
    isAllowable
    isRestricted
    isAutoSkipped
    isAutoAllowed
    isPurse
    massiveLayout
    hasBaseAmmount
    isFreeAmmount
    isCard
    isByRequest
    isMultiPrice
    cardBaseAmmount
    minCardBaseAmmount
    maxCardBaseAmmount
    nameExternal
    unspsc
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductoMutationVariables,
  APITypes.UpdateProductoMutation
>;
export const deleteProducto = /* GraphQL */ `mutation DeleteProducto(
  $input: DeleteProductoInput!
  $condition: ModelProductoConditionInput
) {
  deleteProducto(input: $input, condition: $condition) {
    id
    providerId
    categoryId
    name
    status
    bestSeller
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    order
    sku
    brand
    colors
    pgClasitication
    delivery_time
    delivery_time_units
    stock
    minRequest
    maxRequest
    article_of_clothing
    size
    price
    long_description
    short_description
    creator
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    isExternal
    isAllowable
    isRestricted
    isAutoSkipped
    isAutoAllowed
    isPurse
    massiveLayout
    hasBaseAmmount
    isFreeAmmount
    isCard
    isByRequest
    isMultiPrice
    cardBaseAmmount
    minCardBaseAmmount
    maxCardBaseAmmount
    nameExternal
    unspsc
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductoMutationVariables,
  APITypes.DeleteProductoMutation
>;
export const createProductVariant = /* GraphQL */ `mutation CreateProductVariant(
  $input: CreateProductVariantInput!
  $condition: ModelProductVariantConditionInput
) {
  createProductVariant(input: $input, condition: $condition) {
    id
    productId
    sku
    name
    description
    colors
    filterColors
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock_available
    price
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductVariantMutationVariables,
  APITypes.CreateProductVariantMutation
>;
export const updateProductVariant = /* GraphQL */ `mutation UpdateProductVariant(
  $input: UpdateProductVariantInput!
  $condition: ModelProductVariantConditionInput
) {
  updateProductVariant(input: $input, condition: $condition) {
    id
    productId
    sku
    name
    description
    colors
    filterColors
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock_available
    price
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductVariantMutationVariables,
  APITypes.UpdateProductVariantMutation
>;
export const deleteProductVariant = /* GraphQL */ `mutation DeleteProductVariant(
  $input: DeleteProductVariantInput!
  $condition: ModelProductVariantConditionInput
) {
  deleteProductVariant(input: $input, condition: $condition) {
    id
    productId
    sku
    name
    description
    colors
    filterColors
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock_available
    price
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductVariantMutationVariables,
  APITypes.DeleteProductVariantMutation
>;
export const createProductOption = /* GraphQL */ `mutation CreateProductOption(
  $input: CreateProductOptionInput!
  $condition: ModelProductOptionConditionInput
) {
  createProductOption(input: $input, condition: $condition) {
    id
    ownOrder
    isPangga
    volumetricWeight
    isEvaluated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductOptionMutationVariables,
  APITypes.CreateProductOptionMutation
>;
export const updateProductOption = /* GraphQL */ `mutation UpdateProductOption(
  $input: UpdateProductOptionInput!
  $condition: ModelProductOptionConditionInput
) {
  updateProductOption(input: $input, condition: $condition) {
    id
    ownOrder
    isPangga
    volumetricWeight
    isEvaluated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductOptionMutationVariables,
  APITypes.UpdateProductOptionMutation
>;
export const deleteProductOption = /* GraphQL */ `mutation DeleteProductOption(
  $input: DeleteProductOptionInput!
  $condition: ModelProductOptionConditionInput
) {
  deleteProductOption(input: $input, condition: $condition) {
    id
    ownOrder
    isPangga
    volumetricWeight
    isEvaluated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductOptionMutationVariables,
  APITypes.DeleteProductOptionMutation
>;
export const createProductDimention = /* GraphQL */ `mutation CreateProductDimention(
  $input: CreateProductDimentionInput!
  $condition: ModelProductDimentionConditionInput
) {
  createProductDimention(input: $input, condition: $condition) {
    id
    width
    height
    depth
    weight
    boxWidth
    boxHeight
    boxDepth
    boxWeight
    boxQuantity
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductDimentionMutationVariables,
  APITypes.CreateProductDimentionMutation
>;
export const updateProductDimention = /* GraphQL */ `mutation UpdateProductDimention(
  $input: UpdateProductDimentionInput!
  $condition: ModelProductDimentionConditionInput
) {
  updateProductDimention(input: $input, condition: $condition) {
    id
    width
    height
    depth
    weight
    boxWidth
    boxHeight
    boxDepth
    boxWeight
    boxQuantity
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductDimentionMutationVariables,
  APITypes.UpdateProductDimentionMutation
>;
export const deleteProductDimention = /* GraphQL */ `mutation DeleteProductDimention(
  $input: DeleteProductDimentionInput!
  $condition: ModelProductDimentionConditionInput
) {
  deleteProductDimention(input: $input, condition: $condition) {
    id
    width
    height
    depth
    weight
    boxWidth
    boxHeight
    boxDepth
    boxWeight
    boxQuantity
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductDimentionMutationVariables,
  APITypes.DeleteProductDimentionMutation
>;
export const createMassiveChangeLayouts = /* GraphQL */ `mutation CreateMassiveChangeLayouts(
  $input: CreateMassiveChangeLayoutsInput!
  $condition: ModelMassiveChangeLayoutsConditionInput
) {
  createMassiveChangeLayouts(input: $input, condition: $condition) {
    id
    type
    status
    providerId
    creatorId
    creatorRole
    productsNumber
    file {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMassiveChangeLayoutsMutationVariables,
  APITypes.CreateMassiveChangeLayoutsMutation
>;
export const updateMassiveChangeLayouts = /* GraphQL */ `mutation UpdateMassiveChangeLayouts(
  $input: UpdateMassiveChangeLayoutsInput!
  $condition: ModelMassiveChangeLayoutsConditionInput
) {
  updateMassiveChangeLayouts(input: $input, condition: $condition) {
    id
    type
    status
    providerId
    creatorId
    creatorRole
    productsNumber
    file {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMassiveChangeLayoutsMutationVariables,
  APITypes.UpdateMassiveChangeLayoutsMutation
>;
export const deleteMassiveChangeLayouts = /* GraphQL */ `mutation DeleteMassiveChangeLayouts(
  $input: DeleteMassiveChangeLayoutsInput!
  $condition: ModelMassiveChangeLayoutsConditionInput
) {
  deleteMassiveChangeLayouts(input: $input, condition: $condition) {
    id
    type
    status
    providerId
    creatorId
    creatorRole
    productsNumber
    file {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMassiveChangeLayoutsMutationVariables,
  APITypes.DeleteMassiveChangeLayoutsMutation
>;
export const createCategory = /* GraphQL */ `mutation CreateCategory(
  $input: CreateCategoryInput!
  $condition: ModelCategoryConditionInput
) {
  createCategory(input: $input, condition: $condition) {
    id
    name
    description
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    imageMobile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    visibleForUserBrand
    region
    tags
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isPublic
    isTop
    createdAt
    slug
    parentId
    rootId
    path
    status
    pathIds
    depth
    childrenCount
    isLeaf
    oldVersion
    productLine
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCategoryMutationVariables,
  APITypes.CreateCategoryMutation
>;
export const updateCategory = /* GraphQL */ `mutation UpdateCategory(
  $input: UpdateCategoryInput!
  $condition: ModelCategoryConditionInput
) {
  updateCategory(input: $input, condition: $condition) {
    id
    name
    description
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    imageMobile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    visibleForUserBrand
    region
    tags
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isPublic
    isTop
    createdAt
    slug
    parentId
    rootId
    path
    status
    pathIds
    depth
    childrenCount
    isLeaf
    oldVersion
    productLine
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCategoryMutationVariables,
  APITypes.UpdateCategoryMutation
>;
export const deleteCategory = /* GraphQL */ `mutation DeleteCategory(
  $input: DeleteCategoryInput!
  $condition: ModelCategoryConditionInput
) {
  deleteCategory(input: $input, condition: $condition) {
    id
    name
    description
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    imageMobile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    visibleForUserBrand
    region
    tags
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isPublic
    isTop
    createdAt
    slug
    parentId
    rootId
    path
    status
    pathIds
    depth
    childrenCount
    isLeaf
    oldVersion
    productLine
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCategoryMutationVariables,
  APITypes.DeleteCategoryMutation
>;
export const createProductBrand = /* GraphQL */ `mutation CreateProductBrand(
  $input: CreateProductBrandInput!
  $condition: ModelProductBrandConditionInput
) {
  createProductBrand(input: $input, condition: $condition) {
    id
    name
    status
    description
    route
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isTop
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductBrandMutationVariables,
  APITypes.CreateProductBrandMutation
>;
export const updateProductBrand = /* GraphQL */ `mutation UpdateProductBrand(
  $input: UpdateProductBrandInput!
  $condition: ModelProductBrandConditionInput
) {
  updateProductBrand(input: $input, condition: $condition) {
    id
    name
    status
    description
    route
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isTop
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductBrandMutationVariables,
  APITypes.UpdateProductBrandMutation
>;
export const deleteProductBrand = /* GraphQL */ `mutation DeleteProductBrand(
  $input: DeleteProductBrandInput!
  $condition: ModelProductBrandConditionInput
) {
  deleteProductBrand(input: $input, condition: $condition) {
    id
    name
    status
    description
    route
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isTop
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductBrandMutationVariables,
  APITypes.DeleteProductBrandMutation
>;
export const createCart = /* GraphQL */ `mutation CreateCart(
  $input: CreateCartInput!
  $condition: ModelCartConditionInput
) {
  createCart(input: $input, condition: $condition) {
    id
    requirement
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    products {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    creator
    contact {
      name
      tel
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCartMutationVariables,
  APITypes.CreateCartMutation
>;
export const updateCart = /* GraphQL */ `mutation UpdateCart(
  $input: UpdateCartInput!
  $condition: ModelCartConditionInput
) {
  updateCart(input: $input, condition: $condition) {
    id
    requirement
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    products {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    creator
    contact {
      name
      tel
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCartMutationVariables,
  APITypes.UpdateCartMutation
>;
export const deleteCart = /* GraphQL */ `mutation DeleteCart(
  $input: DeleteCartInput!
  $condition: ModelCartConditionInput
) {
  deleteCart(input: $input, condition: $condition) {
    id
    requirement
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    products {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    creator
    contact {
      name
      tel
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCartMutationVariables,
  APITypes.DeleteCartMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    name
    role
    email
    jiraId
    phoneNumber
    avatar {
      key
      url
      color
      palette
      colorName
      __typename
    }
    companyId
    brandId
    failedLogins
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    notificationsOf
    status
    isLogistic
    isCoupa
    isManagement
    isAdministration
    hasNotifications
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    name
    role
    email
    jiraId
    phoneNumber
    avatar {
      key
      url
      color
      palette
      colorName
      __typename
    }
    companyId
    brandId
    failedLogins
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    notificationsOf
    status
    isLogistic
    isCoupa
    isManagement
    isAdministration
    hasNotifications
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    name
    role
    email
    jiraId
    phoneNumber
    avatar {
      key
      url
      color
      palette
      colorName
      __typename
    }
    companyId
    brandId
    failedLogins
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    notificationsOf
    status
    isLogistic
    isCoupa
    isManagement
    isAdministration
    hasNotifications
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createAutomobile = /* GraphQL */ `mutation CreateAutomobile(
  $input: CreateAutomobileInput!
  $condition: ModelAutomobileConditionInput
) {
  createAutomobile(input: $input, condition: $condition) {
    id
    clientId
    status
    bought
    buyerId
    buyerName
    price
    brand
    brandId
    model
    version
    year
    color
    km
    transmission
    motor
    passengers
    state
    objeto
    placa
    serialNumber
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    star_time
    end_time
    usersInteresting {
      iduser
      nombre
      email
      fecha_compra
      veces_rechazo
      winner
      fecha_notificacion
      buyer
      process_buyer
      d_winner_date
      created
      __typename
    }
    comentario
    penalizacion
    haveWinner
    ppostulacion
    logsGanadoresAutos {
      items {
        id
        id_auto
        id_user
        fecha_rifa
        email
        nombre
        a_paterno
        a_materno
        status_buyer
        date_buyer
        winner
        refused
        since
        process_buyer
        reactive
        created
        updated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAutomobileMutationVariables,
  APITypes.CreateAutomobileMutation
>;
export const updateAutomobile = /* GraphQL */ `mutation UpdateAutomobile(
  $input: UpdateAutomobileInput!
  $condition: ModelAutomobileConditionInput
) {
  updateAutomobile(input: $input, condition: $condition) {
    id
    clientId
    status
    bought
    buyerId
    buyerName
    price
    brand
    brandId
    model
    version
    year
    color
    km
    transmission
    motor
    passengers
    state
    objeto
    placa
    serialNumber
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    star_time
    end_time
    usersInteresting {
      iduser
      nombre
      email
      fecha_compra
      veces_rechazo
      winner
      fecha_notificacion
      buyer
      process_buyer
      d_winner_date
      created
      __typename
    }
    comentario
    penalizacion
    haveWinner
    ppostulacion
    logsGanadoresAutos {
      items {
        id
        id_auto
        id_user
        fecha_rifa
        email
        nombre
        a_paterno
        a_materno
        status_buyer
        date_buyer
        winner
        refused
        since
        process_buyer
        reactive
        created
        updated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAutomobileMutationVariables,
  APITypes.UpdateAutomobileMutation
>;
export const deleteAutomobile = /* GraphQL */ `mutation DeleteAutomobile(
  $input: DeleteAutomobileInput!
  $condition: ModelAutomobileConditionInput
) {
  deleteAutomobile(input: $input, condition: $condition) {
    id
    clientId
    status
    bought
    buyerId
    buyerName
    price
    brand
    brandId
    model
    version
    year
    color
    km
    transmission
    motor
    passengers
    state
    objeto
    placa
    serialNumber
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    star_time
    end_time
    usersInteresting {
      iduser
      nombre
      email
      fecha_compra
      veces_rechazo
      winner
      fecha_notificacion
      buyer
      process_buyer
      d_winner_date
      created
      __typename
    }
    comentario
    penalizacion
    haveWinner
    ppostulacion
    logsGanadoresAutos {
      items {
        id
        id_auto
        id_user
        fecha_rifa
        email
        nombre
        a_paterno
        a_materno
        status_buyer
        date_buyer
        winner
        refused
        since
        process_buyer
        reactive
        created
        updated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAutomobileMutationVariables,
  APITypes.DeleteAutomobileMutation
>;
export const createBrand = /* GraphQL */ `mutation CreateBrand(
  $input: CreateBrandInput!
  $condition: ModelBrandConditionInput
) {
  createBrand(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBrandMutationVariables,
  APITypes.CreateBrandMutation
>;
export const updateBrand = /* GraphQL */ `mutation UpdateBrand(
  $input: UpdateBrandInput!
  $condition: ModelBrandConditionInput
) {
  updateBrand(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBrandMutationVariables,
  APITypes.UpdateBrandMutation
>;
export const deleteBrand = /* GraphQL */ `mutation DeleteBrand(
  $input: DeleteBrandInput!
  $condition: ModelBrandConditionInput
) {
  deleteBrand(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBrandMutationVariables,
  APITypes.DeleteBrandMutation
>;
export const createRfq = /* GraphQL */ `mutation CreateRfq(
  $input: CreateRfqInput!
  $condition: ModelRfqConditionInput
) {
  createRfq(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          premiumOrderId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    premiumOrderId
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRfqMutationVariables,
  APITypes.CreateRfqMutation
>;
export const updateRfq = /* GraphQL */ `mutation UpdateRfq(
  $input: UpdateRfqInput!
  $condition: ModelRfqConditionInput
) {
  updateRfq(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          premiumOrderId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    premiumOrderId
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRfqMutationVariables,
  APITypes.UpdateRfqMutation
>;
export const deleteRfq = /* GraphQL */ `mutation DeleteRfq(
  $input: DeleteRfqInput!
  $condition: ModelRfqConditionInput
) {
  deleteRfq(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          premiumOrderId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    premiumOrderId
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRfqMutationVariables,
  APITypes.DeleteRfqMutation
>;
export const createRfqAmazon = /* GraphQL */ `mutation CreateRfqAmazon(
  $input: CreateRfqAmazonInput!
  $condition: ModelRfqAmazonConditionInput
) {
  createRfqAmazon(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRfqAmazonMutationVariables,
  APITypes.CreateRfqAmazonMutation
>;
export const updateRfqAmazon = /* GraphQL */ `mutation UpdateRfqAmazon(
  $input: UpdateRfqAmazonInput!
  $condition: ModelRfqAmazonConditionInput
) {
  updateRfqAmazon(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRfqAmazonMutationVariables,
  APITypes.UpdateRfqAmazonMutation
>;
export const deleteRfqAmazon = /* GraphQL */ `mutation DeleteRfqAmazon(
  $input: DeleteRfqAmazonInput!
  $condition: ModelRfqAmazonConditionInput
) {
  deleteRfqAmazon(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRfqAmazonMutationVariables,
  APITypes.DeleteRfqAmazonMutation
>;
export const createProposals = /* GraphQL */ `mutation CreateProposals(
  $input: CreateProposalsInput!
  $condition: ModelProposalsConditionInput
) {
  createProposals(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      premiumOrderId
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProposalsMutationVariables,
  APITypes.CreateProposalsMutation
>;
export const updateProposals = /* GraphQL */ `mutation UpdateProposals(
  $input: UpdateProposalsInput!
  $condition: ModelProposalsConditionInput
) {
  updateProposals(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      premiumOrderId
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProposalsMutationVariables,
  APITypes.UpdateProposalsMutation
>;
export const deleteProposals = /* GraphQL */ `mutation DeleteProposals(
  $input: DeleteProposalsInput!
  $condition: ModelProposalsConditionInput
) {
  deleteProposals(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      premiumOrderId
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProposalsMutationVariables,
  APITypes.DeleteProposalsMutation
>;
export const createProposalsAmazon = /* GraphQL */ `mutation CreateProposalsAmazon(
  $input: CreateProposalsAmazonInput!
  $condition: ModelProposalsAmazonConditionInput
) {
  createProposalsAmazon(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProposalsAmazonMutationVariables,
  APITypes.CreateProposalsAmazonMutation
>;
export const updateProposalsAmazon = /* GraphQL */ `mutation UpdateProposalsAmazon(
  $input: UpdateProposalsAmazonInput!
  $condition: ModelProposalsAmazonConditionInput
) {
  updateProposalsAmazon(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProposalsAmazonMutationVariables,
  APITypes.UpdateProposalsAmazonMutation
>;
export const deleteProposalsAmazon = /* GraphQL */ `mutation DeleteProposalsAmazon(
  $input: DeleteProposalsAmazonInput!
  $condition: ModelProposalsAmazonConditionInput
) {
  deleteProposalsAmazon(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProposalsAmazonMutationVariables,
  APITypes.DeleteProposalsAmazonMutation
>;
export const createProductoRfq = /* GraphQL */ `mutation CreateProductoRfq(
  $input: CreateProductoRfqInput!
  $condition: ModelProductoRfqConditionInput
) {
  createProductoRfq(input: $input, condition: $condition) {
    id
    name
    request
    category_id
    provider_id
    price
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductoRfqMutationVariables,
  APITypes.CreateProductoRfqMutation
>;
export const updateProductoRfq = /* GraphQL */ `mutation UpdateProductoRfq(
  $input: UpdateProductoRfqInput!
  $condition: ModelProductoRfqConditionInput
) {
  updateProductoRfq(input: $input, condition: $condition) {
    id
    name
    request
    category_id
    provider_id
    price
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductoRfqMutationVariables,
  APITypes.UpdateProductoRfqMutation
>;
export const deleteProductoRfq = /* GraphQL */ `mutation DeleteProductoRfq(
  $input: DeleteProductoRfqInput!
  $condition: ModelProductoRfqConditionInput
) {
  deleteProductoRfq(input: $input, condition: $condition) {
    id
    name
    request
    category_id
    provider_id
    price
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductoRfqMutationVariables,
  APITypes.DeleteProductoRfqMutation
>;
export const createOrderProviders = /* GraphQL */ `mutation CreateOrderProviders(
  $input: CreateOrderProvidersInput!
  $condition: ModelOrderProvidersConditionInput
) {
  createOrderProviders(input: $input, condition: $condition) {
    id
    provider_id
    clientId
    orderId
    orderProvidersPremiumOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrderProvidersMutationVariables,
  APITypes.CreateOrderProvidersMutation
>;
export const updateOrderProviders = /* GraphQL */ `mutation UpdateOrderProviders(
  $input: UpdateOrderProvidersInput!
  $condition: ModelOrderProvidersConditionInput
) {
  updateOrderProviders(input: $input, condition: $condition) {
    id
    provider_id
    clientId
    orderId
    orderProvidersPremiumOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderProvidersMutationVariables,
  APITypes.UpdateOrderProvidersMutation
>;
export const deleteOrderProviders = /* GraphQL */ `mutation DeleteOrderProviders(
  $input: DeleteOrderProvidersInput!
  $condition: ModelOrderProvidersConditionInput
) {
  deleteOrderProviders(input: $input, condition: $condition) {
    id
    provider_id
    clientId
    orderId
    orderProvidersPremiumOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrderProvidersMutationVariables,
  APITypes.DeleteOrderProvidersMutation
>;
export const createLogGanadorAuto = /* GraphQL */ `mutation CreateLogGanadorAuto(
  $input: CreateLogGanadorAutoInput!
  $condition: ModelLogGanadorAutoConditionInput
) {
  createLogGanadorAuto(input: $input, condition: $condition) {
    id
    id_auto
    id_user
    fecha_rifa
    email
    nombre
    a_paterno
    a_materno
    status_buyer
    date_buyer
    winner
    refused
    since
    process_buyer
    reactive
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogGanadorAutoMutationVariables,
  APITypes.CreateLogGanadorAutoMutation
>;
export const updateLogGanadorAuto = /* GraphQL */ `mutation UpdateLogGanadorAuto(
  $input: UpdateLogGanadorAutoInput!
  $condition: ModelLogGanadorAutoConditionInput
) {
  updateLogGanadorAuto(input: $input, condition: $condition) {
    id
    id_auto
    id_user
    fecha_rifa
    email
    nombre
    a_paterno
    a_materno
    status_buyer
    date_buyer
    winner
    refused
    since
    process_buyer
    reactive
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogGanadorAutoMutationVariables,
  APITypes.UpdateLogGanadorAutoMutation
>;
export const deleteLogGanadorAuto = /* GraphQL */ `mutation DeleteLogGanadorAuto(
  $input: DeleteLogGanadorAutoInput!
  $condition: ModelLogGanadorAutoConditionInput
) {
  deleteLogGanadorAuto(input: $input, condition: $condition) {
    id
    id_auto
    id_user
    fecha_rifa
    email
    nombre
    a_paterno
    a_materno
    status_buyer
    date_buyer
    winner
    refused
    since
    process_buyer
    reactive
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogGanadorAutoMutationVariables,
  APITypes.DeleteLogGanadorAutoMutation
>;
export const createPopMaterial = /* GraphQL */ `mutation CreatePopMaterial(
  $input: CreatePopMaterialInput!
  $condition: ModelPopMaterialConditionInput
) {
  createPopMaterial(input: $input, condition: $condition) {
    id
    name
    route
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    year
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePopMaterialMutationVariables,
  APITypes.CreatePopMaterialMutation
>;
export const updatePopMaterial = /* GraphQL */ `mutation UpdatePopMaterial(
  $input: UpdatePopMaterialInput!
  $condition: ModelPopMaterialConditionInput
) {
  updatePopMaterial(input: $input, condition: $condition) {
    id
    name
    route
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    year
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePopMaterialMutationVariables,
  APITypes.UpdatePopMaterialMutation
>;
export const deletePopMaterial = /* GraphQL */ `mutation DeletePopMaterial(
  $input: DeletePopMaterialInput!
  $condition: ModelPopMaterialConditionInput
) {
  deletePopMaterial(input: $input, condition: $condition) {
    id
    name
    route
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    year
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePopMaterialMutationVariables,
  APITypes.DeletePopMaterialMutation
>;
export const createVehicleType = /* GraphQL */ `mutation CreateVehicleType(
  $input: CreateVehicleTypeInput!
  $condition: ModelVehicleTypeConditionInput
) {
  createVehicleType(input: $input, condition: $condition) {
    id
    name
    popMaterialId
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    popMaterial {
      id
      name
      route
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      year
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVehicleTypeMutationVariables,
  APITypes.CreateVehicleTypeMutation
>;
export const updateVehicleType = /* GraphQL */ `mutation UpdateVehicleType(
  $input: UpdateVehicleTypeInput!
  $condition: ModelVehicleTypeConditionInput
) {
  updateVehicleType(input: $input, condition: $condition) {
    id
    name
    popMaterialId
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    popMaterial {
      id
      name
      route
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      year
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateVehicleTypeMutationVariables,
  APITypes.UpdateVehicleTypeMutation
>;
export const deleteVehicleType = /* GraphQL */ `mutation DeleteVehicleType(
  $input: DeleteVehicleTypeInput!
  $condition: ModelVehicleTypeConditionInput
) {
  deleteVehicleType(input: $input, condition: $condition) {
    id
    name
    popMaterialId
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    popMaterial {
      id
      name
      route
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      year
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteVehicleTypeMutationVariables,
  APITypes.DeleteVehicleTypeMutation
>;
export const createVehicle = /* GraphQL */ `mutation CreateVehicle(
  $input: CreateVehicleInput!
  $condition: ModelVehicleConditionInput
) {
  createVehicle(input: $input, condition: $condition) {
    id
    status
    isSustainable
    multiProvider
    itemName
    bestSeller
    name
    brand
    channel
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    description
    size
    materialDetail
    print
    finish
    packaging
    quantity
    unitPrice
    prototypePrice
    productionTime
    vehicleTypeId
    popMaterialId
    popCategoryId
    providerId
    isRfq
    historicCost
    historicTime
    contact
    providerName
    variantsUnits {
      min_units
      max_units
      price
      production_time
      __typename
    }
    visibleFor
    filterColors
    providers
    massiveLayout
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVehicleMutationVariables,
  APITypes.CreateVehicleMutation
>;
export const updateVehicle = /* GraphQL */ `mutation UpdateVehicle(
  $input: UpdateVehicleInput!
  $condition: ModelVehicleConditionInput
) {
  updateVehicle(input: $input, condition: $condition) {
    id
    status
    isSustainable
    multiProvider
    itemName
    bestSeller
    name
    brand
    channel
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    description
    size
    materialDetail
    print
    finish
    packaging
    quantity
    unitPrice
    prototypePrice
    productionTime
    vehicleTypeId
    popMaterialId
    popCategoryId
    providerId
    isRfq
    historicCost
    historicTime
    contact
    providerName
    variantsUnits {
      min_units
      max_units
      price
      production_time
      __typename
    }
    visibleFor
    filterColors
    providers
    massiveLayout
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateVehicleMutationVariables,
  APITypes.UpdateVehicleMutation
>;
export const deleteVehicle = /* GraphQL */ `mutation DeleteVehicle(
  $input: DeleteVehicleInput!
  $condition: ModelVehicleConditionInput
) {
  deleteVehicle(input: $input, condition: $condition) {
    id
    status
    isSustainable
    multiProvider
    itemName
    bestSeller
    name
    brand
    channel
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    description
    size
    materialDetail
    print
    finish
    packaging
    quantity
    unitPrice
    prototypePrice
    productionTime
    vehicleTypeId
    popMaterialId
    popCategoryId
    providerId
    isRfq
    historicCost
    historicTime
    contact
    providerName
    variantsUnits {
      min_units
      max_units
      price
      production_time
      __typename
    }
    visibleFor
    filterColors
    providers
    massiveLayout
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteVehicleMutationVariables,
  APITypes.DeleteVehicleMutation
>;
export const createPopOrder = /* GraphQL */ `mutation CreatePopOrder(
  $input: CreatePopOrderInput!
  $condition: ModelPopOrderConditionInput
) {
  createPopOrder(input: $input, condition: $condition) {
    id
    estatus
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    orderId
    requirement
    budget
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    subtotal
    total
    isCoupa
    sentToCoupa
    coupaOrder
    active
    vehicles {
      items {
        id
        orderId
        vehicleId
        providerId
        unitPrice
        prototypePrice
        quantity
        approved
        hasQrCode
        vehicle {
          id
          status
          isSustainable
          multiProvider
          itemName
          bestSeller
          name
          brand
          channel
          description
          size
          materialDetail
          print
          finish
          packaging
          quantity
          unitPrice
          prototypePrice
          productionTime
          vehicleTypeId
          popMaterialId
          popCategoryId
          providerId
          isRfq
          historicCost
          historicTime
          contact
          providerName
          visibleFor
          filterColors
          providers
          massiveLayout
          created
          updated
          createdAt
          updatedAt
          __typename
        }
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        sampleTestDate
        sampleTestDateApproved
        prototypeDate
        prototypeDateApproved
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    gr
    orderCreatorId
    providers {
      items {
        id
        orderId
        providerId
        deliveryDateRequested
        grRequested
        invoiceUploaded
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    prequoteApproved
    quoteApproved
    prototypeApproved
    samplesDocsUploaded
    samplesApproved
    auditRequired
    drivePath
    auditDocsUploaded
    deliveryDateRequested
    deliveryDate
    deliveryCode
    deliveryFilesUploaded
    deliveryDocsApproved
    grUploaded
    grApproved
    grCode
    qrCode
    brandfactoryCheck
    step
    prototype
    dateKickoff
    paymentDate
    currentProcess
    currentSubprocess
    clientId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePopOrderMutationVariables,
  APITypes.CreatePopOrderMutation
>;
export const updatePopOrder = /* GraphQL */ `mutation UpdatePopOrder(
  $input: UpdatePopOrderInput!
  $condition: ModelPopOrderConditionInput
) {
  updatePopOrder(input: $input, condition: $condition) {
    id
    estatus
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    orderId
    requirement
    budget
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    subtotal
    total
    isCoupa
    sentToCoupa
    coupaOrder
    active
    vehicles {
      items {
        id
        orderId
        vehicleId
        providerId
        unitPrice
        prototypePrice
        quantity
        approved
        hasQrCode
        vehicle {
          id
          status
          isSustainable
          multiProvider
          itemName
          bestSeller
          name
          brand
          channel
          description
          size
          materialDetail
          print
          finish
          packaging
          quantity
          unitPrice
          prototypePrice
          productionTime
          vehicleTypeId
          popMaterialId
          popCategoryId
          providerId
          isRfq
          historicCost
          historicTime
          contact
          providerName
          visibleFor
          filterColors
          providers
          massiveLayout
          created
          updated
          createdAt
          updatedAt
          __typename
        }
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        sampleTestDate
        sampleTestDateApproved
        prototypeDate
        prototypeDateApproved
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    gr
    orderCreatorId
    providers {
      items {
        id
        orderId
        providerId
        deliveryDateRequested
        grRequested
        invoiceUploaded
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    prequoteApproved
    quoteApproved
    prototypeApproved
    samplesDocsUploaded
    samplesApproved
    auditRequired
    drivePath
    auditDocsUploaded
    deliveryDateRequested
    deliveryDate
    deliveryCode
    deliveryFilesUploaded
    deliveryDocsApproved
    grUploaded
    grApproved
    grCode
    qrCode
    brandfactoryCheck
    step
    prototype
    dateKickoff
    paymentDate
    currentProcess
    currentSubprocess
    clientId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePopOrderMutationVariables,
  APITypes.UpdatePopOrderMutation
>;
export const deletePopOrder = /* GraphQL */ `mutation DeletePopOrder(
  $input: DeletePopOrderInput!
  $condition: ModelPopOrderConditionInput
) {
  deletePopOrder(input: $input, condition: $condition) {
    id
    estatus
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    orderId
    requirement
    budget
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    subtotal
    total
    isCoupa
    sentToCoupa
    coupaOrder
    active
    vehicles {
      items {
        id
        orderId
        vehicleId
        providerId
        unitPrice
        prototypePrice
        quantity
        approved
        hasQrCode
        vehicle {
          id
          status
          isSustainable
          multiProvider
          itemName
          bestSeller
          name
          brand
          channel
          description
          size
          materialDetail
          print
          finish
          packaging
          quantity
          unitPrice
          prototypePrice
          productionTime
          vehicleTypeId
          popMaterialId
          popCategoryId
          providerId
          isRfq
          historicCost
          historicTime
          contact
          providerName
          visibleFor
          filterColors
          providers
          massiveLayout
          created
          updated
          createdAt
          updatedAt
          __typename
        }
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        sampleTestDate
        sampleTestDateApproved
        prototypeDate
        prototypeDateApproved
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    gr
    orderCreatorId
    providers {
      items {
        id
        orderId
        providerId
        deliveryDateRequested
        grRequested
        invoiceUploaded
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    prequoteApproved
    quoteApproved
    prototypeApproved
    samplesDocsUploaded
    samplesApproved
    auditRequired
    drivePath
    auditDocsUploaded
    deliveryDateRequested
    deliveryDate
    deliveryCode
    deliveryFilesUploaded
    deliveryDocsApproved
    grUploaded
    grApproved
    grCode
    qrCode
    brandfactoryCheck
    step
    prototype
    dateKickoff
    paymentDate
    currentProcess
    currentSubprocess
    clientId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePopOrderMutationVariables,
  APITypes.DeletePopOrderMutation
>;
export const createOrderFile = /* GraphQL */ `mutation CreateOrderFile(
  $input: CreateOrderFileInput!
  $condition: ModelOrderFileConditionInput
) {
  createOrderFile(input: $input, condition: $condition) {
    id
    createdAt
    creatorId
    orderId
    key
    url
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrderFileMutationVariables,
  APITypes.CreateOrderFileMutation
>;
export const updateOrderFile = /* GraphQL */ `mutation UpdateOrderFile(
  $input: UpdateOrderFileInput!
  $condition: ModelOrderFileConditionInput
) {
  updateOrderFile(input: $input, condition: $condition) {
    id
    createdAt
    creatorId
    orderId
    key
    url
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderFileMutationVariables,
  APITypes.UpdateOrderFileMutation
>;
export const deleteOrderFile = /* GraphQL */ `mutation DeleteOrderFile(
  $input: DeleteOrderFileInput!
  $condition: ModelOrderFileConditionInput
) {
  deleteOrderFile(input: $input, condition: $condition) {
    id
    createdAt
    creatorId
    orderId
    key
    url
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrderFileMutationVariables,
  APITypes.DeleteOrderFileMutation
>;
export const createPopOrderVehicle = /* GraphQL */ `mutation CreatePopOrderVehicle(
  $input: CreatePopOrderVehicleInput!
  $condition: ModelPopOrderVehicleConditionInput
) {
  createPopOrderVehicle(input: $input, condition: $condition) {
    id
    orderId
    vehicleId
    providerId
    unitPrice
    prototypePrice
    quantity
    approved
    hasQrCode
    vehicle {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    sampleTestDate
    sampleTestDateApproved
    prototypeDate
    prototypeDateApproved
    logs {
      product_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePopOrderVehicleMutationVariables,
  APITypes.CreatePopOrderVehicleMutation
>;
export const updatePopOrderVehicle = /* GraphQL */ `mutation UpdatePopOrderVehicle(
  $input: UpdatePopOrderVehicleInput!
  $condition: ModelPopOrderVehicleConditionInput
) {
  updatePopOrderVehicle(input: $input, condition: $condition) {
    id
    orderId
    vehicleId
    providerId
    unitPrice
    prototypePrice
    quantity
    approved
    hasQrCode
    vehicle {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    sampleTestDate
    sampleTestDateApproved
    prototypeDate
    prototypeDateApproved
    logs {
      product_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePopOrderVehicleMutationVariables,
  APITypes.UpdatePopOrderVehicleMutation
>;
export const deletePopOrderVehicle = /* GraphQL */ `mutation DeletePopOrderVehicle(
  $input: DeletePopOrderVehicleInput!
  $condition: ModelPopOrderVehicleConditionInput
) {
  deletePopOrderVehicle(input: $input, condition: $condition) {
    id
    orderId
    vehicleId
    providerId
    unitPrice
    prototypePrice
    quantity
    approved
    hasQrCode
    vehicle {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    sampleTestDate
    sampleTestDateApproved
    prototypeDate
    prototypeDateApproved
    logs {
      product_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePopOrderVehicleMutationVariables,
  APITypes.DeletePopOrderVehicleMutation
>;
export const createPopOrderAuthorizer = /* GraphQL */ `mutation CreatePopOrderAuthorizer(
  $input: CreatePopOrderAuthorizerInput!
  $condition: ModelPopOrderAuthorizerConditionInput
) {
  createPopOrderAuthorizer(input: $input, condition: $condition) {
    id
    userId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePopOrderAuthorizerMutationVariables,
  APITypes.CreatePopOrderAuthorizerMutation
>;
export const updatePopOrderAuthorizer = /* GraphQL */ `mutation UpdatePopOrderAuthorizer(
  $input: UpdatePopOrderAuthorizerInput!
  $condition: ModelPopOrderAuthorizerConditionInput
) {
  updatePopOrderAuthorizer(input: $input, condition: $condition) {
    id
    userId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePopOrderAuthorizerMutationVariables,
  APITypes.UpdatePopOrderAuthorizerMutation
>;
export const deletePopOrderAuthorizer = /* GraphQL */ `mutation DeletePopOrderAuthorizer(
  $input: DeletePopOrderAuthorizerInput!
  $condition: ModelPopOrderAuthorizerConditionInput
) {
  deletePopOrderAuthorizer(input: $input, condition: $condition) {
    id
    userId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePopOrderAuthorizerMutationVariables,
  APITypes.DeletePopOrderAuthorizerMutation
>;
export const createPopOrderProvider = /* GraphQL */ `mutation CreatePopOrderProvider(
  $input: CreatePopOrderProviderInput!
  $condition: ModelPopOrderProviderConditionInput
) {
  createPopOrderProvider(input: $input, condition: $condition) {
    id
    orderId
    providerId
    deliveryDateRequested
    grRequested
    invoiceUploaded
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePopOrderProviderMutationVariables,
  APITypes.CreatePopOrderProviderMutation
>;
export const updatePopOrderProvider = /* GraphQL */ `mutation UpdatePopOrderProvider(
  $input: UpdatePopOrderProviderInput!
  $condition: ModelPopOrderProviderConditionInput
) {
  updatePopOrderProvider(input: $input, condition: $condition) {
    id
    orderId
    providerId
    deliveryDateRequested
    grRequested
    invoiceUploaded
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePopOrderProviderMutationVariables,
  APITypes.UpdatePopOrderProviderMutation
>;
export const deletePopOrderProvider = /* GraphQL */ `mutation DeletePopOrderProvider(
  $input: DeletePopOrderProviderInput!
  $condition: ModelPopOrderProviderConditionInput
) {
  deletePopOrderProvider(input: $input, condition: $condition) {
    id
    orderId
    providerId
    deliveryDateRequested
    grRequested
    invoiceUploaded
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePopOrderProviderMutationVariables,
  APITypes.DeletePopOrderProviderMutation
>;
export const createPopOrderLog = /* GraphQL */ `mutation CreatePopOrderLog(
  $input: CreatePopOrderLogInput!
  $condition: ModelPopOrderLogConditionInput
) {
  createPopOrderLog(input: $input, condition: $condition) {
    id
    orderId
    creatorId
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    createdAt
    text
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePopOrderLogMutationVariables,
  APITypes.CreatePopOrderLogMutation
>;
export const updatePopOrderLog = /* GraphQL */ `mutation UpdatePopOrderLog(
  $input: UpdatePopOrderLogInput!
  $condition: ModelPopOrderLogConditionInput
) {
  updatePopOrderLog(input: $input, condition: $condition) {
    id
    orderId
    creatorId
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    createdAt
    text
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePopOrderLogMutationVariables,
  APITypes.UpdatePopOrderLogMutation
>;
export const deletePopOrderLog = /* GraphQL */ `mutation DeletePopOrderLog(
  $input: DeletePopOrderLogInput!
  $condition: ModelPopOrderLogConditionInput
) {
  deletePopOrderLog(input: $input, condition: $condition) {
    id
    orderId
    creatorId
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    createdAt
    text
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePopOrderLogMutationVariables,
  APITypes.DeletePopOrderLogMutation
>;
export const createRfqPop = /* GraphQL */ `mutation CreateRfqPop(
  $input: CreateRfqPopInput!
  $condition: ModelRfqPopConditionInput
) {
  createRfqPop(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    vehicleTypeId
    popMaterialId
    vehiclesRfq {
      vehicleTypeId
      popMaterialId
      name
      description
      pieces
      createdId
      __typename
    }
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        created
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        vehicles {
          productUnitRfqIndex
          selected
          name
          popMaterialId
          vehicleTypeId
          brand
          size
          description
          quantity
          packaging
          materialDetail
          print
          unitPrice
          pieces
          priceUnit
          total
          idProducto
          __typename
        }
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        rfq {
          id
          nombre
          requerimiento
          vehicleTypeId
          popMaterialId
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          popOrderId
          orderId
          estatus
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          budget
          hasQrCode
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        proposalsPopRfqId
        prototypePrice
        hidden
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    popOrderId
    orderId
    estatus
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    budget
    hasQrCode
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRfqPopMutationVariables,
  APITypes.CreateRfqPopMutation
>;
export const updateRfqPop = /* GraphQL */ `mutation UpdateRfqPop(
  $input: UpdateRfqPopInput!
  $condition: ModelRfqPopConditionInput
) {
  updateRfqPop(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    vehicleTypeId
    popMaterialId
    vehiclesRfq {
      vehicleTypeId
      popMaterialId
      name
      description
      pieces
      createdId
      __typename
    }
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        created
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        vehicles {
          productUnitRfqIndex
          selected
          name
          popMaterialId
          vehicleTypeId
          brand
          size
          description
          quantity
          packaging
          materialDetail
          print
          unitPrice
          pieces
          priceUnit
          total
          idProducto
          __typename
        }
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        rfq {
          id
          nombre
          requerimiento
          vehicleTypeId
          popMaterialId
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          popOrderId
          orderId
          estatus
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          budget
          hasQrCode
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        proposalsPopRfqId
        prototypePrice
        hidden
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    popOrderId
    orderId
    estatus
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    budget
    hasQrCode
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRfqPopMutationVariables,
  APITypes.UpdateRfqPopMutation
>;
export const deleteRfqPop = /* GraphQL */ `mutation DeleteRfqPop(
  $input: DeleteRfqPopInput!
  $condition: ModelRfqPopConditionInput
) {
  deleteRfqPop(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    vehicleTypeId
    popMaterialId
    vehiclesRfq {
      vehicleTypeId
      popMaterialId
      name
      description
      pieces
      createdId
      __typename
    }
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        created
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        vehicles {
          productUnitRfqIndex
          selected
          name
          popMaterialId
          vehicleTypeId
          brand
          size
          description
          quantity
          packaging
          materialDetail
          print
          unitPrice
          pieces
          priceUnit
          total
          idProducto
          __typename
        }
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        rfq {
          id
          nombre
          requerimiento
          vehicleTypeId
          popMaterialId
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          popOrderId
          orderId
          estatus
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          budget
          hasQrCode
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        proposalsPopRfqId
        prototypePrice
        hidden
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    popOrderId
    orderId
    estatus
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    budget
    hasQrCode
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRfqPopMutationVariables,
  APITypes.DeleteRfqPopMutation
>;
export const createProposalsPop = /* GraphQL */ `mutation CreateProposalsPop(
  $input: CreateProposalsPopInput!
  $condition: ModelProposalsPopConditionInput
) {
  createProposalsPop(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    created
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    vehicles {
      productUnitRfqIndex
      selected
      name
      popMaterialId
      vehicleTypeId
      brand
      size
      description
      quantity
      packaging
      materialDetail
      print
      unitPrice
      pieces
      priceUnit
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    rfq {
      id
      nombre
      requerimiento
      vehicleTypeId
      popMaterialId
      vehiclesRfq {
        vehicleTypeId
        popMaterialId
        name
        description
        pieces
        createdId
        __typename
      }
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          created
          validity_days
          description
          updated
          proposalsPopRfqId
          prototypePrice
          hidden
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      popOrderId
      orderId
      estatus
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      budget
      hasQrCode
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    proposalsPopRfqId
    prototypePrice
    hidden
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProposalsPopMutationVariables,
  APITypes.CreateProposalsPopMutation
>;
export const updateProposalsPop = /* GraphQL */ `mutation UpdateProposalsPop(
  $input: UpdateProposalsPopInput!
  $condition: ModelProposalsPopConditionInput
) {
  updateProposalsPop(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    created
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    vehicles {
      productUnitRfqIndex
      selected
      name
      popMaterialId
      vehicleTypeId
      brand
      size
      description
      quantity
      packaging
      materialDetail
      print
      unitPrice
      pieces
      priceUnit
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    rfq {
      id
      nombre
      requerimiento
      vehicleTypeId
      popMaterialId
      vehiclesRfq {
        vehicleTypeId
        popMaterialId
        name
        description
        pieces
        createdId
        __typename
      }
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          created
          validity_days
          description
          updated
          proposalsPopRfqId
          prototypePrice
          hidden
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      popOrderId
      orderId
      estatus
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      budget
      hasQrCode
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    proposalsPopRfqId
    prototypePrice
    hidden
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProposalsPopMutationVariables,
  APITypes.UpdateProposalsPopMutation
>;
export const deleteProposalsPop = /* GraphQL */ `mutation DeleteProposalsPop(
  $input: DeleteProposalsPopInput!
  $condition: ModelProposalsPopConditionInput
) {
  deleteProposalsPop(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    created
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    vehicles {
      productUnitRfqIndex
      selected
      name
      popMaterialId
      vehicleTypeId
      brand
      size
      description
      quantity
      packaging
      materialDetail
      print
      unitPrice
      pieces
      priceUnit
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    rfq {
      id
      nombre
      requerimiento
      vehicleTypeId
      popMaterialId
      vehiclesRfq {
        vehicleTypeId
        popMaterialId
        name
        description
        pieces
        createdId
        __typename
      }
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          created
          validity_days
          description
          updated
          proposalsPopRfqId
          prototypePrice
          hidden
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      popOrderId
      orderId
      estatus
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      budget
      hasQrCode
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    proposalsPopRfqId
    prototypePrice
    hidden
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProposalsPopMutationVariables,
  APITypes.DeleteProposalsPopMutation
>;
export const createUsersBrands = /* GraphQL */ `mutation CreateUsersBrands(
  $input: CreateUsersBrandsInput!
  $condition: ModelUsersBrandsConditionInput
) {
  createUsersBrands(input: $input, condition: $condition) {
    id
    name
    description
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    status
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUsersBrandsMutationVariables,
  APITypes.CreateUsersBrandsMutation
>;
export const updateUsersBrands = /* GraphQL */ `mutation UpdateUsersBrands(
  $input: UpdateUsersBrandsInput!
  $condition: ModelUsersBrandsConditionInput
) {
  updateUsersBrands(input: $input, condition: $condition) {
    id
    name
    description
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    status
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUsersBrandsMutationVariables,
  APITypes.UpdateUsersBrandsMutation
>;
export const deleteUsersBrands = /* GraphQL */ `mutation DeleteUsersBrands(
  $input: DeleteUsersBrandsInput!
  $condition: ModelUsersBrandsConditionInput
) {
  deleteUsersBrands(input: $input, condition: $condition) {
    id
    name
    description
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    status
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUsersBrandsMutationVariables,
  APITypes.DeleteUsersBrandsMutation
>;
export const createUserBrandSetting = /* GraphQL */ `mutation CreateUserBrandSetting(
  $input: CreateUserBrandSettingInput!
  $condition: ModelUserBrandSettingConditionInput
) {
  createUserBrandSetting(input: $input, condition: $condition) {
    id
    categories
    subcategories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserBrandSettingMutationVariables,
  APITypes.CreateUserBrandSettingMutation
>;
export const updateUserBrandSetting = /* GraphQL */ `mutation UpdateUserBrandSetting(
  $input: UpdateUserBrandSettingInput!
  $condition: ModelUserBrandSettingConditionInput
) {
  updateUserBrandSetting(input: $input, condition: $condition) {
    id
    categories
    subcategories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserBrandSettingMutationVariables,
  APITypes.UpdateUserBrandSettingMutation
>;
export const deleteUserBrandSetting = /* GraphQL */ `mutation DeleteUserBrandSetting(
  $input: DeleteUserBrandSettingInput!
  $condition: ModelUserBrandSettingConditionInput
) {
  deleteUserBrandSetting(input: $input, condition: $condition) {
    id
    categories
    subcategories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserBrandSettingMutationVariables,
  APITypes.DeleteUserBrandSettingMutation
>;
export const createLogsPUsers = /* GraphQL */ `mutation CreateLogsPUsers(
  $input: CreateLogsPUsersInput!
  $condition: ModelLogsPUsersConditionInput
) {
  createLogsPUsers(input: $input, condition: $condition) {
    id
    user
    keyword
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogsPUsersMutationVariables,
  APITypes.CreateLogsPUsersMutation
>;
export const updateLogsPUsers = /* GraphQL */ `mutation UpdateLogsPUsers(
  $input: UpdateLogsPUsersInput!
  $condition: ModelLogsPUsersConditionInput
) {
  updateLogsPUsers(input: $input, condition: $condition) {
    id
    user
    keyword
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogsPUsersMutationVariables,
  APITypes.UpdateLogsPUsersMutation
>;
export const deleteLogsPUsers = /* GraphQL */ `mutation DeleteLogsPUsers(
  $input: DeleteLogsPUsersInput!
  $condition: ModelLogsPUsersConditionInput
) {
  deleteLogsPUsers(input: $input, condition: $condition) {
    id
    user
    keyword
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogsPUsersMutationVariables,
  APITypes.DeleteLogsPUsersMutation
>;
export const createClipPayment = /* GraphQL */ `mutation CreateClipPayment(
  $input: CreateClipPaymentInput!
  $condition: ModelClipPaymentConditionInput
) {
  createClipPayment(input: $input, condition: $condition) {
    id
    status
    requestsCount
    payment_request_id
    purchase_description
    orderId
    clientId
    userId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateClipPaymentMutationVariables,
  APITypes.CreateClipPaymentMutation
>;
export const updateClipPayment = /* GraphQL */ `mutation UpdateClipPayment(
  $input: UpdateClipPaymentInput!
  $condition: ModelClipPaymentConditionInput
) {
  updateClipPayment(input: $input, condition: $condition) {
    id
    status
    requestsCount
    payment_request_id
    purchase_description
    orderId
    clientId
    userId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClipPaymentMutationVariables,
  APITypes.UpdateClipPaymentMutation
>;
export const deleteClipPayment = /* GraphQL */ `mutation DeleteClipPayment(
  $input: DeleteClipPaymentInput!
  $condition: ModelClipPaymentConditionInput
) {
  deleteClipPayment(input: $input, condition: $condition) {
    id
    status
    requestsCount
    payment_request_id
    purchase_description
    orderId
    clientId
    userId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteClipPaymentMutationVariables,
  APITypes.DeleteClipPaymentMutation
>;
export const createEtPayPayment = /* GraphQL */ `mutation CreateEtPayPayment(
  $input: CreateEtPayPaymentInput!
  $condition: ModelEtPayPaymentConditionInput
) {
  createEtPayPayment(input: $input, condition: $condition) {
    id
    status
    requestCount
    signatureToken
    purchaseDescription
    orderId
    clientId
    userId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEtPayPaymentMutationVariables,
  APITypes.CreateEtPayPaymentMutation
>;
export const updateEtPayPayment = /* GraphQL */ `mutation UpdateEtPayPayment(
  $input: UpdateEtPayPaymentInput!
  $condition: ModelEtPayPaymentConditionInput
) {
  updateEtPayPayment(input: $input, condition: $condition) {
    id
    status
    requestCount
    signatureToken
    purchaseDescription
    orderId
    clientId
    userId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEtPayPaymentMutationVariables,
  APITypes.UpdateEtPayPaymentMutation
>;
export const deleteEtPayPayment = /* GraphQL */ `mutation DeleteEtPayPayment(
  $input: DeleteEtPayPaymentInput!
  $condition: ModelEtPayPaymentConditionInput
) {
  deleteEtPayPayment(input: $input, condition: $condition) {
    id
    status
    requestCount
    signatureToken
    purchaseDescription
    orderId
    clientId
    userId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEtPayPaymentMutationVariables,
  APITypes.DeleteEtPayPaymentMutation
>;
export const createOrderProcess = /* GraphQL */ `mutation CreateOrderProcess(
  $input: CreateOrderProcessInput!
  $condition: ModelOrderProcessConditionInput
) {
  createOrderProcess(input: $input, condition: $condition) {
    id
    type
    status
    tcdPayment
    name
    duration
    descripcion
    position
    responsible
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    cards {
      id
      name
      permissions {
        idCard
        rol
        thirdContent
        visible
        __typename
      }
      __typename
    }
    subprocesses {
      items {
        id
        type
        status
        name
        position
        descripcion
        action
        process {
          id
          type
          status
          tcdPayment
          name
          duration
          descripcion
          position
          responsible
          clientId
          createdAt
          updatedAt
          __typename
        }
        processId
        clientId
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrderProcessMutationVariables,
  APITypes.CreateOrderProcessMutation
>;
export const updateOrderProcess = /* GraphQL */ `mutation UpdateOrderProcess(
  $input: UpdateOrderProcessInput!
  $condition: ModelOrderProcessConditionInput
) {
  updateOrderProcess(input: $input, condition: $condition) {
    id
    type
    status
    tcdPayment
    name
    duration
    descripcion
    position
    responsible
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    cards {
      id
      name
      permissions {
        idCard
        rol
        thirdContent
        visible
        __typename
      }
      __typename
    }
    subprocesses {
      items {
        id
        type
        status
        name
        position
        descripcion
        action
        process {
          id
          type
          status
          tcdPayment
          name
          duration
          descripcion
          position
          responsible
          clientId
          createdAt
          updatedAt
          __typename
        }
        processId
        clientId
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderProcessMutationVariables,
  APITypes.UpdateOrderProcessMutation
>;
export const deleteOrderProcess = /* GraphQL */ `mutation DeleteOrderProcess(
  $input: DeleteOrderProcessInput!
  $condition: ModelOrderProcessConditionInput
) {
  deleteOrderProcess(input: $input, condition: $condition) {
    id
    type
    status
    tcdPayment
    name
    duration
    descripcion
    position
    responsible
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    cards {
      id
      name
      permissions {
        idCard
        rol
        thirdContent
        visible
        __typename
      }
      __typename
    }
    subprocesses {
      items {
        id
        type
        status
        name
        position
        descripcion
        action
        process {
          id
          type
          status
          tcdPayment
          name
          duration
          descripcion
          position
          responsible
          clientId
          createdAt
          updatedAt
          __typename
        }
        processId
        clientId
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrderProcessMutationVariables,
  APITypes.DeleteOrderProcessMutation
>;
export const createOrderSubprocess = /* GraphQL */ `mutation CreateOrderSubprocess(
  $input: CreateOrderSubprocessInput!
  $condition: ModelOrderSubprocessConditionInput
) {
  createOrderSubprocess(input: $input, condition: $condition) {
    id
    type
    status
    name
    position
    descripcion
    action
    process {
      id
      type
      status
      tcdPayment
      name
      duration
      descripcion
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        items {
          id
          type
          status
          name
          position
          descripcion
          action
          processId
          clientId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      clientId
      createdAt
      updatedAt
      __typename
    }
    processId
    clientId
    messages {
      description
      rol
      visibleAction
      __typename
    }
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrderSubprocessMutationVariables,
  APITypes.CreateOrderSubprocessMutation
>;
export const updateOrderSubprocess = /* GraphQL */ `mutation UpdateOrderSubprocess(
  $input: UpdateOrderSubprocessInput!
  $condition: ModelOrderSubprocessConditionInput
) {
  updateOrderSubprocess(input: $input, condition: $condition) {
    id
    type
    status
    name
    position
    descripcion
    action
    process {
      id
      type
      status
      tcdPayment
      name
      duration
      descripcion
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        items {
          id
          type
          status
          name
          position
          descripcion
          action
          processId
          clientId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      clientId
      createdAt
      updatedAt
      __typename
    }
    processId
    clientId
    messages {
      description
      rol
      visibleAction
      __typename
    }
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderSubprocessMutationVariables,
  APITypes.UpdateOrderSubprocessMutation
>;
export const deleteOrderSubprocess = /* GraphQL */ `mutation DeleteOrderSubprocess(
  $input: DeleteOrderSubprocessInput!
  $condition: ModelOrderSubprocessConditionInput
) {
  deleteOrderSubprocess(input: $input, condition: $condition) {
    id
    type
    status
    name
    position
    descripcion
    action
    process {
      id
      type
      status
      tcdPayment
      name
      duration
      descripcion
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        items {
          id
          type
          status
          name
          position
          descripcion
          action
          processId
          clientId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      clientId
      createdAt
      updatedAt
      __typename
    }
    processId
    clientId
    messages {
      description
      rol
      visibleAction
      __typename
    }
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrderSubprocessMutationVariables,
  APITypes.DeleteOrderSubprocessMutation
>;
export const createQualityPGForms = /* GraphQL */ `mutation CreateQualityPGForms(
  $input: CreateQualityPGFormsInput!
  $condition: ModelQualityPGFormsConditionInput
) {
  createQualityPGForms(input: $input, condition: $condition) {
    id
    initiativeDescription
    targetUser
    retailBrandName
    itemCategory
    itemPicture
    originCountry
    quantityPerCountryOfDist
    initiativeDates
    isPartOfAnMSOCustOrSpecPack
    incluesClientLogo
    isAReorderWithinTwelveMonths
    isReorder
    PGPLContactName
    ulTracking
    PLContactName
    contactEmailAddress
    PGPurchaseOrderNumber
    EBBSorSupplierProvidedProjectNumber
    vendorCompanyName
    vendorContactName
    vendorEmailAddress
    vendorJobTitle
    vendorTelephone
    vendorMailingAddress
    vendorCity
    vendorState
    vendorCountry
    vendorPC
    physicalItemDescription
    SampleOrMaterialComponentSubmitted
    toWhom
    descriptionOfItemPackagingAndArtwork
    regulatoryAndLegislativeProductCertification
    dateFinalApprovalRequestedSubmittedToPG
    DateOfDeclarationOfConformity
    dateOfApprovalExpirationOfPremiumItem
    itemClasification
    PGRepresentativeMarketingDesign
    PGProjectLeaderRequestor
    PGRestrictedItemsLocalPGLegal
    PGLocalCategoryGM
    PGLocalCategoryJoanAbbinanteNissenNotPowered
    idProduct
    pathDocument
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateQualityPGFormsMutationVariables,
  APITypes.CreateQualityPGFormsMutation
>;
export const updateQualityPGForms = /* GraphQL */ `mutation UpdateQualityPGForms(
  $input: UpdateQualityPGFormsInput!
  $condition: ModelQualityPGFormsConditionInput
) {
  updateQualityPGForms(input: $input, condition: $condition) {
    id
    initiativeDescription
    targetUser
    retailBrandName
    itemCategory
    itemPicture
    originCountry
    quantityPerCountryOfDist
    initiativeDates
    isPartOfAnMSOCustOrSpecPack
    incluesClientLogo
    isAReorderWithinTwelveMonths
    isReorder
    PGPLContactName
    ulTracking
    PLContactName
    contactEmailAddress
    PGPurchaseOrderNumber
    EBBSorSupplierProvidedProjectNumber
    vendorCompanyName
    vendorContactName
    vendorEmailAddress
    vendorJobTitle
    vendorTelephone
    vendorMailingAddress
    vendorCity
    vendorState
    vendorCountry
    vendorPC
    physicalItemDescription
    SampleOrMaterialComponentSubmitted
    toWhom
    descriptionOfItemPackagingAndArtwork
    regulatoryAndLegislativeProductCertification
    dateFinalApprovalRequestedSubmittedToPG
    DateOfDeclarationOfConformity
    dateOfApprovalExpirationOfPremiumItem
    itemClasification
    PGRepresentativeMarketingDesign
    PGProjectLeaderRequestor
    PGRestrictedItemsLocalPGLegal
    PGLocalCategoryGM
    PGLocalCategoryJoanAbbinanteNissenNotPowered
    idProduct
    pathDocument
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateQualityPGFormsMutationVariables,
  APITypes.UpdateQualityPGFormsMutation
>;
export const deleteQualityPGForms = /* GraphQL */ `mutation DeleteQualityPGForms(
  $input: DeleteQualityPGFormsInput!
  $condition: ModelQualityPGFormsConditionInput
) {
  deleteQualityPGForms(input: $input, condition: $condition) {
    id
    initiativeDescription
    targetUser
    retailBrandName
    itemCategory
    itemPicture
    originCountry
    quantityPerCountryOfDist
    initiativeDates
    isPartOfAnMSOCustOrSpecPack
    incluesClientLogo
    isAReorderWithinTwelveMonths
    isReorder
    PGPLContactName
    ulTracking
    PLContactName
    contactEmailAddress
    PGPurchaseOrderNumber
    EBBSorSupplierProvidedProjectNumber
    vendorCompanyName
    vendorContactName
    vendorEmailAddress
    vendorJobTitle
    vendorTelephone
    vendorMailingAddress
    vendorCity
    vendorState
    vendorCountry
    vendorPC
    physicalItemDescription
    SampleOrMaterialComponentSubmitted
    toWhom
    descriptionOfItemPackagingAndArtwork
    regulatoryAndLegislativeProductCertification
    dateFinalApprovalRequestedSubmittedToPG
    DateOfDeclarationOfConformity
    dateOfApprovalExpirationOfPremiumItem
    itemClasification
    PGRepresentativeMarketingDesign
    PGProjectLeaderRequestor
    PGRestrictedItemsLocalPGLegal
    PGLocalCategoryGM
    PGLocalCategoryJoanAbbinanteNissenNotPowered
    idProduct
    pathDocument
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteQualityPGFormsMutationVariables,
  APITypes.DeleteQualityPGFormsMutation
>;
export const createPremiumOrder = /* GraphQL */ `mutation CreatePremiumOrder(
  $input: CreatePremiumOrderInput!
  $condition: ModelPremiumOrderConditionInput
) {
  createPremiumOrder(input: $input, condition: $condition) {
    id
    requirement
    bank_reference
    hasVat
    billingData {
      name
      rfc
      regimen
      cfdi_use
      cp
      email
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      __typename
    }
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    logs {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      role
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_fee
    delivery_discount
    delivery_time
    delivery_date
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    taxSituationFile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clipUrl
    clipStatus
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    providers {
      items {
        id
        provider_id
        clientId
        orderId
        orderProvidersPremiumOrderId
        payment_date
        gr_code
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    listsProducts {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    invoiceContact {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    premiumOrderClientId
    client {
      id
      status
      business_name
      comertial_name
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      biography
      plan
      fee
      increment
      mercadoFee
      mercadoIncrement
      popFee
      popIncrement
      printedFee
      printedIncrement
      users
      restrictedUsers
      nonRestrictedUsers
      regions
      providers
      popProviders
      printedProviders
      logisticFrequency
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      administrators {
        id
        name
        email
        phoneNumber
        __typename
      }
      signDocument {
        url
        enabled
        __typename
      }
      legal_representative
      legal_representative_email
      legal_representative_address
      tcdUsers
      billingUsers {
        id
        name
        email
        phoneNumber
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    userBrandId
    userBrand {
      id
      name
      description
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      clientId
      createdAt
      updatedAt
      __typename
    }
    subtotal
    fee
    printedPrice
    total
    discountAmount
    syncWithCrm
    crmIssueKey
    sentToAlendum
    alendumProjectId
    syncWithFms
    fmsInvoiceId
    syncWithWms
    wmsProjectId
    isCoupa
    sentToCoupa
    isRfq
    requireSamples
    requestedSamples
    approvedSamples
    authorizedQA
    active
    currentProcess
    currentSubprocess
    processes {
      id
      name
      descripcion
      duration
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      madeBy
      madeAt
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        id
        name
        position
        descripcion
        action
        process
        madeBy
        madeAt
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        __typename
      }
      __typename
    }
    updatedAt
    created
    updated
    logistic {
      premiumOrderId
      tracking_number
      destiny_latitude
      destiny_longitude
      status
      status_activity
      status_description
      origin_latitude
      origin_longitude
      carrier
      clave_sat
      customer_delivery_start_date
      customer_email
      customer_external_number
      customer_first_name
      customer_last_name
      customer_mobile_number
      customer_postcode
      customer_settlement
      customer_street
      descripcion_sat
      peligroso
      primary_client
      purchase_order_number
      shipping_method
      shipping_option
      created
      __typename
    }
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePremiumOrderMutationVariables,
  APITypes.CreatePremiumOrderMutation
>;
export const updatePremiumOrder = /* GraphQL */ `mutation UpdatePremiumOrder(
  $input: UpdatePremiumOrderInput!
  $condition: ModelPremiumOrderConditionInput
) {
  updatePremiumOrder(input: $input, condition: $condition) {
    id
    requirement
    bank_reference
    hasVat
    billingData {
      name
      rfc
      regimen
      cfdi_use
      cp
      email
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      __typename
    }
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    logs {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      role
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_fee
    delivery_discount
    delivery_time
    delivery_date
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    taxSituationFile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clipUrl
    clipStatus
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    providers {
      items {
        id
        provider_id
        clientId
        orderId
        orderProvidersPremiumOrderId
        payment_date
        gr_code
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    listsProducts {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    invoiceContact {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    premiumOrderClientId
    client {
      id
      status
      business_name
      comertial_name
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      biography
      plan
      fee
      increment
      mercadoFee
      mercadoIncrement
      popFee
      popIncrement
      printedFee
      printedIncrement
      users
      restrictedUsers
      nonRestrictedUsers
      regions
      providers
      popProviders
      printedProviders
      logisticFrequency
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      administrators {
        id
        name
        email
        phoneNumber
        __typename
      }
      signDocument {
        url
        enabled
        __typename
      }
      legal_representative
      legal_representative_email
      legal_representative_address
      tcdUsers
      billingUsers {
        id
        name
        email
        phoneNumber
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    userBrandId
    userBrand {
      id
      name
      description
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      clientId
      createdAt
      updatedAt
      __typename
    }
    subtotal
    fee
    printedPrice
    total
    discountAmount
    syncWithCrm
    crmIssueKey
    sentToAlendum
    alendumProjectId
    syncWithFms
    fmsInvoiceId
    syncWithWms
    wmsProjectId
    isCoupa
    sentToCoupa
    isRfq
    requireSamples
    requestedSamples
    approvedSamples
    authorizedQA
    active
    currentProcess
    currentSubprocess
    processes {
      id
      name
      descripcion
      duration
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      madeBy
      madeAt
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        id
        name
        position
        descripcion
        action
        process
        madeBy
        madeAt
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        __typename
      }
      __typename
    }
    updatedAt
    created
    updated
    logistic {
      premiumOrderId
      tracking_number
      destiny_latitude
      destiny_longitude
      status
      status_activity
      status_description
      origin_latitude
      origin_longitude
      carrier
      clave_sat
      customer_delivery_start_date
      customer_email
      customer_external_number
      customer_first_name
      customer_last_name
      customer_mobile_number
      customer_postcode
      customer_settlement
      customer_street
      descripcion_sat
      peligroso
      primary_client
      purchase_order_number
      shipping_method
      shipping_option
      created
      __typename
    }
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePremiumOrderMutationVariables,
  APITypes.UpdatePremiumOrderMutation
>;
export const deletePremiumOrder = /* GraphQL */ `mutation DeletePremiumOrder(
  $input: DeletePremiumOrderInput!
  $condition: ModelPremiumOrderConditionInput
) {
  deletePremiumOrder(input: $input, condition: $condition) {
    id
    requirement
    bank_reference
    hasVat
    billingData {
      name
      rfc
      regimen
      cfdi_use
      cp
      email
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      __typename
    }
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    logs {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      role
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_fee
    delivery_discount
    delivery_time
    delivery_date
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    taxSituationFile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clipUrl
    clipStatus
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    providers {
      items {
        id
        provider_id
        clientId
        orderId
        orderProvidersPremiumOrderId
        payment_date
        gr_code
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    listsProducts {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    invoiceContact {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    premiumOrderClientId
    client {
      id
      status
      business_name
      comertial_name
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      biography
      plan
      fee
      increment
      mercadoFee
      mercadoIncrement
      popFee
      popIncrement
      printedFee
      printedIncrement
      users
      restrictedUsers
      nonRestrictedUsers
      regions
      providers
      popProviders
      printedProviders
      logisticFrequency
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      administrators {
        id
        name
        email
        phoneNumber
        __typename
      }
      signDocument {
        url
        enabled
        __typename
      }
      legal_representative
      legal_representative_email
      legal_representative_address
      tcdUsers
      billingUsers {
        id
        name
        email
        phoneNumber
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    userBrandId
    userBrand {
      id
      name
      description
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      clientId
      createdAt
      updatedAt
      __typename
    }
    subtotal
    fee
    printedPrice
    total
    discountAmount
    syncWithCrm
    crmIssueKey
    sentToAlendum
    alendumProjectId
    syncWithFms
    fmsInvoiceId
    syncWithWms
    wmsProjectId
    isCoupa
    sentToCoupa
    isRfq
    requireSamples
    requestedSamples
    approvedSamples
    authorizedQA
    active
    currentProcess
    currentSubprocess
    processes {
      id
      name
      descripcion
      duration
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      madeBy
      madeAt
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        id
        name
        position
        descripcion
        action
        process
        madeBy
        madeAt
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        __typename
      }
      __typename
    }
    updatedAt
    created
    updated
    logistic {
      premiumOrderId
      tracking_number
      destiny_latitude
      destiny_longitude
      status
      status_activity
      status_description
      origin_latitude
      origin_longitude
      carrier
      clave_sat
      customer_delivery_start_date
      customer_email
      customer_external_number
      customer_first_name
      customer_last_name
      customer_mobile_number
      customer_postcode
      customer_settlement
      customer_street
      descripcion_sat
      peligroso
      primary_client
      purchase_order_number
      shipping_method
      shipping_option
      created
      __typename
    }
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePremiumOrderMutationVariables,
  APITypes.DeletePremiumOrderMutation
>;
export const createPrintedCart = /* GraphQL */ `mutation CreatePrintedCart(
  $input: CreatePrintedCartInput!
  $condition: ModelPrintedCartConditionInput
) {
  createPrintedCart(input: $input, condition: $condition) {
    id
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      name
      type
      tracking_code
      provider_id
      product_id
      description
      __typename
    }
    printedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    creator
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrintedCartMutationVariables,
  APITypes.CreatePrintedCartMutation
>;
export const updatePrintedCart = /* GraphQL */ `mutation UpdatePrintedCart(
  $input: UpdatePrintedCartInput!
  $condition: ModelPrintedCartConditionInput
) {
  updatePrintedCart(input: $input, condition: $condition) {
    id
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      name
      type
      tracking_code
      provider_id
      product_id
      description
      __typename
    }
    printedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    creator
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrintedCartMutationVariables,
  APITypes.UpdatePrintedCartMutation
>;
export const deletePrintedCart = /* GraphQL */ `mutation DeletePrintedCart(
  $input: DeletePrintedCartInput!
  $condition: ModelPrintedCartConditionInput
) {
  deletePrintedCart(input: $input, condition: $condition) {
    id
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      name
      type
      tracking_code
      provider_id
      product_id
      description
      __typename
    }
    printedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    creator
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrintedCartMutationVariables,
  APITypes.DeletePrintedCartMutation
>;
export const createPrintedCategory = /* GraphQL */ `mutation CreatePrintedCategory(
  $input: CreatePrintedCategoryInput!
  $condition: ModelPrintedCategoryConditionInput
) {
  createPrintedCategory(input: $input, condition: $condition) {
    id
    name
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    route
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    printedSubcategories {
      items {
        id
        name
        printedCategoryId
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        parent {
          id
          name
          route
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        created
        printedProducts {
          nextToken
          __typename
        }
        visibleFor
        region
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrintedCategoryMutationVariables,
  APITypes.CreatePrintedCategoryMutation
>;
export const updatePrintedCategory = /* GraphQL */ `mutation UpdatePrintedCategory(
  $input: UpdatePrintedCategoryInput!
  $condition: ModelPrintedCategoryConditionInput
) {
  updatePrintedCategory(input: $input, condition: $condition) {
    id
    name
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    route
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    printedSubcategories {
      items {
        id
        name
        printedCategoryId
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        parent {
          id
          name
          route
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        created
        printedProducts {
          nextToken
          __typename
        }
        visibleFor
        region
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrintedCategoryMutationVariables,
  APITypes.UpdatePrintedCategoryMutation
>;
export const deletePrintedCategory = /* GraphQL */ `mutation DeletePrintedCategory(
  $input: DeletePrintedCategoryInput!
  $condition: ModelPrintedCategoryConditionInput
) {
  deletePrintedCategory(input: $input, condition: $condition) {
    id
    name
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    route
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    printedSubcategories {
      items {
        id
        name
        printedCategoryId
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        parent {
          id
          name
          route
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        created
        printedProducts {
          nextToken
          __typename
        }
        visibleFor
        region
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrintedCategoryMutationVariables,
  APITypes.DeletePrintedCategoryMutation
>;
export const createPrintedSubcategory = /* GraphQL */ `mutation CreatePrintedSubcategory(
  $input: CreatePrintedSubcategoryInput!
  $condition: ModelPrintedSubcategoryConditionInput
) {
  createPrintedSubcategory(input: $input, condition: $condition) {
    id
    name
    printedCategoryId
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    parent {
      id
      name
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      route
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      printedSubcategories {
        items {
          id
          name
          printedCategoryId
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      printedProducts {
        items {
          id
          status
          position
          name
          width
          height
          price
          long_description
          short_description
          creator
          providerId
          finalDimensions
          pagesNumber
          finishes
          inksFourByCero
          inksFourByFour
          paperKind
          grammage
          hasBarniz
          hasRebase
          orientation
          specialInstructions
          PrintedSubcategoryId
          printedCategoryId
          created
          visibleFor
          filterColors
          regions
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      created
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    created
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrintedSubcategoryMutationVariables,
  APITypes.CreatePrintedSubcategoryMutation
>;
export const updatePrintedSubcategory = /* GraphQL */ `mutation UpdatePrintedSubcategory(
  $input: UpdatePrintedSubcategoryInput!
  $condition: ModelPrintedSubcategoryConditionInput
) {
  updatePrintedSubcategory(input: $input, condition: $condition) {
    id
    name
    printedCategoryId
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    parent {
      id
      name
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      route
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      printedSubcategories {
        items {
          id
          name
          printedCategoryId
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      printedProducts {
        items {
          id
          status
          position
          name
          width
          height
          price
          long_description
          short_description
          creator
          providerId
          finalDimensions
          pagesNumber
          finishes
          inksFourByCero
          inksFourByFour
          paperKind
          grammage
          hasBarniz
          hasRebase
          orientation
          specialInstructions
          PrintedSubcategoryId
          printedCategoryId
          created
          visibleFor
          filterColors
          regions
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      created
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    created
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrintedSubcategoryMutationVariables,
  APITypes.UpdatePrintedSubcategoryMutation
>;
export const deletePrintedSubcategory = /* GraphQL */ `mutation DeletePrintedSubcategory(
  $input: DeletePrintedSubcategoryInput!
  $condition: ModelPrintedSubcategoryConditionInput
) {
  deletePrintedSubcategory(input: $input, condition: $condition) {
    id
    name
    printedCategoryId
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    parent {
      id
      name
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      route
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      printedSubcategories {
        items {
          id
          name
          printedCategoryId
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      printedProducts {
        items {
          id
          status
          position
          name
          width
          height
          price
          long_description
          short_description
          creator
          providerId
          finalDimensions
          pagesNumber
          finishes
          inksFourByCero
          inksFourByFour
          paperKind
          grammage
          hasBarniz
          hasRebase
          orientation
          specialInstructions
          PrintedSubcategoryId
          printedCategoryId
          created
          visibleFor
          filterColors
          regions
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      created
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    created
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrintedSubcategoryMutationVariables,
  APITypes.DeletePrintedSubcategoryMutation
>;
export const createPrintedProducts = /* GraphQL */ `mutation CreatePrintedProducts(
  $input: CreatePrintedProductsInput!
  $condition: ModelPrintedProductsConditionInput
) {
  createPrintedProducts(input: $input, condition: $condition) {
    id
    status
    position
    name
    width
    height
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    price
    long_description
    short_description
    creator
    providerId
    finalDimensions
    pagesNumber
    finishes
    inksFourByCero
    inksFourByFour
    paperKind
    grammage
    hasBarniz
    hasRebase
    orientation
    specialInstructions
    PrintedSubcategoryId
    printedCategoryId
    created
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrintedProductsMutationVariables,
  APITypes.CreatePrintedProductsMutation
>;
export const updatePrintedProducts = /* GraphQL */ `mutation UpdatePrintedProducts(
  $input: UpdatePrintedProductsInput!
  $condition: ModelPrintedProductsConditionInput
) {
  updatePrintedProducts(input: $input, condition: $condition) {
    id
    status
    position
    name
    width
    height
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    price
    long_description
    short_description
    creator
    providerId
    finalDimensions
    pagesNumber
    finishes
    inksFourByCero
    inksFourByFour
    paperKind
    grammage
    hasBarniz
    hasRebase
    orientation
    specialInstructions
    PrintedSubcategoryId
    printedCategoryId
    created
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrintedProductsMutationVariables,
  APITypes.UpdatePrintedProductsMutation
>;
export const deletePrintedProducts = /* GraphQL */ `mutation DeletePrintedProducts(
  $input: DeletePrintedProductsInput!
  $condition: ModelPrintedProductsConditionInput
) {
  deletePrintedProducts(input: $input, condition: $condition) {
    id
    status
    position
    name
    width
    height
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    price
    long_description
    short_description
    creator
    providerId
    finalDimensions
    pagesNumber
    finishes
    inksFourByCero
    inksFourByFour
    paperKind
    grammage
    hasBarniz
    hasRebase
    orientation
    specialInstructions
    PrintedSubcategoryId
    printedCategoryId
    created
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrintedProductsMutationVariables,
  APITypes.DeletePrintedProductsMutation
>;
export const createPrintedRfq = /* GraphQL */ `mutation CreatePrintedRfq(
  $input: CreatePrintedRfqInput!
  $condition: ModelPrintedRfqConditionInput
) {
  createPrintedRfq(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        hidden
        rfq {
          id
          nombre
          requerimiento
          limit_time
          creator
          clientId
          estatus
          printedOrderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          __typename
        }
        printedProposalRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    printedOrderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    providers {
      idProvider
      __typename
    }
    printedProductsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrintedRfqMutationVariables,
  APITypes.CreatePrintedRfqMutation
>;
export const updatePrintedRfq = /* GraphQL */ `mutation UpdatePrintedRfq(
  $input: UpdatePrintedRfqInput!
  $condition: ModelPrintedRfqConditionInput
) {
  updatePrintedRfq(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        hidden
        rfq {
          id
          nombre
          requerimiento
          limit_time
          creator
          clientId
          estatus
          printedOrderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          __typename
        }
        printedProposalRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    printedOrderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    providers {
      idProvider
      __typename
    }
    printedProductsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrintedRfqMutationVariables,
  APITypes.UpdatePrintedRfqMutation
>;
export const deletePrintedRfq = /* GraphQL */ `mutation DeletePrintedRfq(
  $input: DeletePrintedRfqInput!
  $condition: ModelPrintedRfqConditionInput
) {
  deletePrintedRfq(input: $input, condition: $condition) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        hidden
        rfq {
          id
          nombre
          requerimiento
          limit_time
          creator
          clientId
          estatus
          printedOrderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          __typename
        }
        printedProposalRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    printedOrderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    providers {
      idProvider
      __typename
    }
    printedProductsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrintedRfqMutationVariables,
  APITypes.DeletePrintedRfqMutation
>;
export const createPrintedProductoRfq = /* GraphQL */ `mutation CreatePrintedProductoRfq(
  $input: CreatePrintedProductoRfqInput!
  $condition: ModelPrintedProductoRfqConditionInput
) {
  createPrintedProductoRfq(input: $input, condition: $condition) {
    id
    name
    description
    category_id
    provider_id
    price
    category
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrintedProductoRfqMutationVariables,
  APITypes.CreatePrintedProductoRfqMutation
>;
export const updatePrintedProductoRfq = /* GraphQL */ `mutation UpdatePrintedProductoRfq(
  $input: UpdatePrintedProductoRfqInput!
  $condition: ModelPrintedProductoRfqConditionInput
) {
  updatePrintedProductoRfq(input: $input, condition: $condition) {
    id
    name
    description
    category_id
    provider_id
    price
    category
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrintedProductoRfqMutationVariables,
  APITypes.UpdatePrintedProductoRfqMutation
>;
export const deletePrintedProductoRfq = /* GraphQL */ `mutation DeletePrintedProductoRfq(
  $input: DeletePrintedProductoRfqInput!
  $condition: ModelPrintedProductoRfqConditionInput
) {
  deletePrintedProductoRfq(input: $input, condition: $condition) {
    id
    name
    description
    category_id
    provider_id
    price
    category
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrintedProductoRfqMutationVariables,
  APITypes.DeletePrintedProductoRfqMutation
>;
export const createPrintedProposal = /* GraphQL */ `mutation CreatePrintedProposal(
  $input: CreatePrintedProposalInput!
  $condition: ModelPrintedProposalConditionInput
) {
  createPrintedProposal(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      proposals {
        items {
          id
          provider_id
          price
          validity_days
          description
          created
          updated
          hidden
          printedProposalRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      printedOrderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      providers {
        idProvider
        __typename
      }
      printedProductsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    printedProposalRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrintedProposalMutationVariables,
  APITypes.CreatePrintedProposalMutation
>;
export const updatePrintedProposal = /* GraphQL */ `mutation UpdatePrintedProposal(
  $input: UpdatePrintedProposalInput!
  $condition: ModelPrintedProposalConditionInput
) {
  updatePrintedProposal(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      proposals {
        items {
          id
          provider_id
          price
          validity_days
          description
          created
          updated
          hidden
          printedProposalRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      printedOrderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      providers {
        idProvider
        __typename
      }
      printedProductsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    printedProposalRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrintedProposalMutationVariables,
  APITypes.UpdatePrintedProposalMutation
>;
export const deletePrintedProposal = /* GraphQL */ `mutation DeletePrintedProposal(
  $input: DeletePrintedProposalInput!
  $condition: ModelPrintedProposalConditionInput
) {
  deletePrintedProposal(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      proposals {
        items {
          id
          provider_id
          price
          validity_days
          description
          created
          updated
          hidden
          printedProposalRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      printedOrderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      providers {
        idProvider
        __typename
      }
      printedProductsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    printedProposalRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrintedProposalMutationVariables,
  APITypes.DeletePrintedProposalMutation
>;
export const createPrintedOrder = /* GraphQL */ `mutation CreatePrintedOrder(
  $input: CreatePrintedOrderInput!
  $condition: ModelPrintedOrderConditionInput
) {
  createPrintedOrder(input: $input, condition: $condition) {
    id
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    listProvidersKey
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    listPrintedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    printedOrderClientId
    subtotal
    total
    isCoupa
    sentToCoupa
    isRfq
    status
    currentProcess
    currentSubprocess
    updatedAt
    created
    updated
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrintedOrderMutationVariables,
  APITypes.CreatePrintedOrderMutation
>;
export const updatePrintedOrder = /* GraphQL */ `mutation UpdatePrintedOrder(
  $input: UpdatePrintedOrderInput!
  $condition: ModelPrintedOrderConditionInput
) {
  updatePrintedOrder(input: $input, condition: $condition) {
    id
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    listProvidersKey
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    listPrintedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    printedOrderClientId
    subtotal
    total
    isCoupa
    sentToCoupa
    isRfq
    status
    currentProcess
    currentSubprocess
    updatedAt
    created
    updated
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrintedOrderMutationVariables,
  APITypes.UpdatePrintedOrderMutation
>;
export const deletePrintedOrder = /* GraphQL */ `mutation DeletePrintedOrder(
  $input: DeletePrintedOrderInput!
  $condition: ModelPrintedOrderConditionInput
) {
  deletePrintedOrder(input: $input, condition: $condition) {
    id
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    listProvidersKey
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    listPrintedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    printedOrderClientId
    subtotal
    total
    isCoupa
    sentToCoupa
    isRfq
    status
    currentProcess
    currentSubprocess
    updatedAt
    created
    updated
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrintedOrderMutationVariables,
  APITypes.DeletePrintedOrderMutation
>;
export const createPrintedOrderProviders = /* GraphQL */ `mutation CreatePrintedOrderProviders(
  $input: CreatePrintedOrderProvidersInput!
  $condition: ModelPrintedOrderProvidersConditionInput
) {
  createPrintedOrderProviders(input: $input, condition: $condition) {
    id
    provider_id
    orderId
    printedOrderProvidersPrintedOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrintedOrderProvidersMutationVariables,
  APITypes.CreatePrintedOrderProvidersMutation
>;
export const updatePrintedOrderProviders = /* GraphQL */ `mutation UpdatePrintedOrderProviders(
  $input: UpdatePrintedOrderProvidersInput!
  $condition: ModelPrintedOrderProvidersConditionInput
) {
  updatePrintedOrderProviders(input: $input, condition: $condition) {
    id
    provider_id
    orderId
    printedOrderProvidersPrintedOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrintedOrderProvidersMutationVariables,
  APITypes.UpdatePrintedOrderProvidersMutation
>;
export const deletePrintedOrderProviders = /* GraphQL */ `mutation DeletePrintedOrderProviders(
  $input: DeletePrintedOrderProvidersInput!
  $condition: ModelPrintedOrderProvidersConditionInput
) {
  deletePrintedOrderProviders(input: $input, condition: $condition) {
    id
    provider_id
    orderId
    printedOrderProvidersPrintedOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrintedOrderProvidersMutationVariables,
  APITypes.DeletePrintedOrderProvidersMutation
>;
export const createPayOnBehalfRequests = /* GraphQL */ `mutation CreatePayOnBehalfRequests(
  $input: CreatePayOnBehalfRequestsInput!
  $condition: ModelPayOnBehalfRequestsConditionInput
) {
  createPayOnBehalfRequests(input: $input, condition: $condition) {
    id
    clientId
    companyName
    purchaseOrder
    paymentTerms
    currency
    amount
    selectedVa
    iva
    vat
    total
    rfc {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bankStatement {
      key
      url
      color
      palette
      colorName
      __typename
    }
    supplierQuote {
      key
      url
      color
      palette
      colorName
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePayOnBehalfRequestsMutationVariables,
  APITypes.CreatePayOnBehalfRequestsMutation
>;
export const updatePayOnBehalfRequests = /* GraphQL */ `mutation UpdatePayOnBehalfRequests(
  $input: UpdatePayOnBehalfRequestsInput!
  $condition: ModelPayOnBehalfRequestsConditionInput
) {
  updatePayOnBehalfRequests(input: $input, condition: $condition) {
    id
    clientId
    companyName
    purchaseOrder
    paymentTerms
    currency
    amount
    selectedVa
    iva
    vat
    total
    rfc {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bankStatement {
      key
      url
      color
      palette
      colorName
      __typename
    }
    supplierQuote {
      key
      url
      color
      palette
      colorName
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePayOnBehalfRequestsMutationVariables,
  APITypes.UpdatePayOnBehalfRequestsMutation
>;
export const deletePayOnBehalfRequests = /* GraphQL */ `mutation DeletePayOnBehalfRequests(
  $input: DeletePayOnBehalfRequestsInput!
  $condition: ModelPayOnBehalfRequestsConditionInput
) {
  deletePayOnBehalfRequests(input: $input, condition: $condition) {
    id
    clientId
    companyName
    purchaseOrder
    paymentTerms
    currency
    amount
    selectedVa
    iva
    vat
    total
    rfc {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bankStatement {
      key
      url
      color
      palette
      colorName
      __typename
    }
    supplierQuote {
      key
      url
      color
      palette
      colorName
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePayOnBehalfRequestsMutationVariables,
  APITypes.DeletePayOnBehalfRequestsMutation
>;
export const createBuyerContactClient = /* GraphQL */ `mutation CreateBuyerContactClient(
  $input: CreateBuyerContactClientInput!
  $condition: ModelBuyerContactClientConditionInput
) {
  createBuyerContactClient(input: $input, condition: $condition) {
    id
    companyId
    status
    defaultContact
    name
    email
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBuyerContactClientMutationVariables,
  APITypes.CreateBuyerContactClientMutation
>;
export const updateBuyerContactClient = /* GraphQL */ `mutation UpdateBuyerContactClient(
  $input: UpdateBuyerContactClientInput!
  $condition: ModelBuyerContactClientConditionInput
) {
  updateBuyerContactClient(input: $input, condition: $condition) {
    id
    companyId
    status
    defaultContact
    name
    email
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBuyerContactClientMutationVariables,
  APITypes.UpdateBuyerContactClientMutation
>;
export const deleteBuyerContactClient = /* GraphQL */ `mutation DeleteBuyerContactClient(
  $input: DeleteBuyerContactClientInput!
  $condition: ModelBuyerContactClientConditionInput
) {
  deleteBuyerContactClient(input: $input, condition: $condition) {
    id
    companyId
    status
    defaultContact
    name
    email
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBuyerContactClientMutationVariables,
  APITypes.DeleteBuyerContactClientMutation
>;
export const createBrandFactoryRfqEmails = /* GraphQL */ `mutation CreateBrandFactoryRfqEmails(
  $input: CreateBrandFactoryRfqEmailsInput!
  $condition: ModelBrandFactoryRfqEmailsConditionInput
) {
  createBrandFactoryRfqEmails(input: $input, condition: $condition) {
    id
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBrandFactoryRfqEmailsMutationVariables,
  APITypes.CreateBrandFactoryRfqEmailsMutation
>;
export const updateBrandFactoryRfqEmails = /* GraphQL */ `mutation UpdateBrandFactoryRfqEmails(
  $input: UpdateBrandFactoryRfqEmailsInput!
  $condition: ModelBrandFactoryRfqEmailsConditionInput
) {
  updateBrandFactoryRfqEmails(input: $input, condition: $condition) {
    id
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBrandFactoryRfqEmailsMutationVariables,
  APITypes.UpdateBrandFactoryRfqEmailsMutation
>;
export const deleteBrandFactoryRfqEmails = /* GraphQL */ `mutation DeleteBrandFactoryRfqEmails(
  $input: DeleteBrandFactoryRfqEmailsInput!
  $condition: ModelBrandFactoryRfqEmailsConditionInput
) {
  deleteBrandFactoryRfqEmails(input: $input, condition: $condition) {
    id
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBrandFactoryRfqEmailsMutationVariables,
  APITypes.DeleteBrandFactoryRfqEmailsMutation
>;
export const createAutomobilesEmails = /* GraphQL */ `mutation CreateAutomobilesEmails(
  $input: CreateAutomobilesEmailsInput!
  $condition: ModelAutomobilesEmailsConditionInput
) {
  createAutomobilesEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAutomobilesEmailsMutationVariables,
  APITypes.CreateAutomobilesEmailsMutation
>;
export const updateAutomobilesEmails = /* GraphQL */ `mutation UpdateAutomobilesEmails(
  $input: UpdateAutomobilesEmailsInput!
  $condition: ModelAutomobilesEmailsConditionInput
) {
  updateAutomobilesEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAutomobilesEmailsMutationVariables,
  APITypes.UpdateAutomobilesEmailsMutation
>;
export const deleteAutomobilesEmails = /* GraphQL */ `mutation DeleteAutomobilesEmails(
  $input: DeleteAutomobilesEmailsInput!
  $condition: ModelAutomobilesEmailsConditionInput
) {
  deleteAutomobilesEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAutomobilesEmailsMutationVariables,
  APITypes.DeleteAutomobilesEmailsMutation
>;
export const createQAEmails = /* GraphQL */ `mutation CreateQAEmails(
  $input: CreateQAEmailsInput!
  $condition: ModelQAEmailsConditionInput
) {
  createQAEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateQAEmailsMutationVariables,
  APITypes.CreateQAEmailsMutation
>;
export const updateQAEmails = /* GraphQL */ `mutation UpdateQAEmails(
  $input: UpdateQAEmailsInput!
  $condition: ModelQAEmailsConditionInput
) {
  updateQAEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateQAEmailsMutationVariables,
  APITypes.UpdateQAEmailsMutation
>;
export const deleteQAEmails = /* GraphQL */ `mutation DeleteQAEmails(
  $input: DeleteQAEmailsInput!
  $condition: ModelQAEmailsConditionInput
) {
  deleteQAEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteQAEmailsMutationVariables,
  APITypes.DeleteQAEmailsMutation
>;
export const createOrderPopAdminEmails = /* GraphQL */ `mutation CreateOrderPopAdminEmails(
  $input: CreateOrderPopAdminEmailsInput!
  $condition: ModelOrderPopAdminEmailsConditionInput
) {
  createOrderPopAdminEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrderPopAdminEmailsMutationVariables,
  APITypes.CreateOrderPopAdminEmailsMutation
>;
export const updateOrderPopAdminEmails = /* GraphQL */ `mutation UpdateOrderPopAdminEmails(
  $input: UpdateOrderPopAdminEmailsInput!
  $condition: ModelOrderPopAdminEmailsConditionInput
) {
  updateOrderPopAdminEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderPopAdminEmailsMutationVariables,
  APITypes.UpdateOrderPopAdminEmailsMutation
>;
export const deleteOrderPopAdminEmails = /* GraphQL */ `mutation DeleteOrderPopAdminEmails(
  $input: DeleteOrderPopAdminEmailsInput!
  $condition: ModelOrderPopAdminEmailsConditionInput
) {
  deleteOrderPopAdminEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrderPopAdminEmailsMutationVariables,
  APITypes.DeleteOrderPopAdminEmailsMutation
>;
export const createOrderPopCheckoutEmails = /* GraphQL */ `mutation CreateOrderPopCheckoutEmails(
  $input: CreateOrderPopCheckoutEmailsInput!
  $condition: ModelOrderPopCheckoutEmailsConditionInput
) {
  createOrderPopCheckoutEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrderPopCheckoutEmailsMutationVariables,
  APITypes.CreateOrderPopCheckoutEmailsMutation
>;
export const updateOrderPopCheckoutEmails = /* GraphQL */ `mutation UpdateOrderPopCheckoutEmails(
  $input: UpdateOrderPopCheckoutEmailsInput!
  $condition: ModelOrderPopCheckoutEmailsConditionInput
) {
  updateOrderPopCheckoutEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderPopCheckoutEmailsMutationVariables,
  APITypes.UpdateOrderPopCheckoutEmailsMutation
>;
export const deleteOrderPopCheckoutEmails = /* GraphQL */ `mutation DeleteOrderPopCheckoutEmails(
  $input: DeleteOrderPopCheckoutEmailsInput!
  $condition: ModelOrderPopCheckoutEmailsConditionInput
) {
  deleteOrderPopCheckoutEmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrderPopCheckoutEmailsMutationVariables,
  APITypes.DeleteOrderPopCheckoutEmailsMutation
>;
export const createGREmails = /* GraphQL */ `mutation CreateGREmails(
  $input: CreateGREmailsInput!
  $condition: ModelGREmailsConditionInput
) {
  createGREmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGREmailsMutationVariables,
  APITypes.CreateGREmailsMutation
>;
export const updateGREmails = /* GraphQL */ `mutation UpdateGREmails(
  $input: UpdateGREmailsInput!
  $condition: ModelGREmailsConditionInput
) {
  updateGREmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGREmailsMutationVariables,
  APITypes.UpdateGREmailsMutation
>;
export const deleteGREmails = /* GraphQL */ `mutation DeleteGREmails(
  $input: DeleteGREmailsInput!
  $condition: ModelGREmailsConditionInput
) {
  deleteGREmails(input: $input, condition: $condition) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteGREmailsMutationVariables,
  APITypes.DeleteGREmailsMutation
>;
export const createRegions = /* GraphQL */ `mutation CreateRegions(
  $input: CreateRegionsInput!
  $condition: ModelRegionsConditionInput
) {
  createRegions(input: $input, condition: $condition) {
    id
    status
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRegionsMutationVariables,
  APITypes.CreateRegionsMutation
>;
export const updateRegions = /* GraphQL */ `mutation UpdateRegions(
  $input: UpdateRegionsInput!
  $condition: ModelRegionsConditionInput
) {
  updateRegions(input: $input, condition: $condition) {
    id
    status
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRegionsMutationVariables,
  APITypes.UpdateRegionsMutation
>;
export const deleteRegions = /* GraphQL */ `mutation DeleteRegions(
  $input: DeleteRegionsInput!
  $condition: ModelRegionsConditionInput
) {
  deleteRegions(input: $input, condition: $condition) {
    id
    status
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRegionsMutationVariables,
  APITypes.DeleteRegionsMutation
>;
export const createDefaultAddress = /* GraphQL */ `mutation CreateDefaultAddress(
  $input: CreateDefaultAddressInput!
  $condition: ModelDefaultAddressConditionInput
) {
  createDefaultAddress(input: $input, condition: $condition) {
    id
    companyId
    userId
    status
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDefaultAddressMutationVariables,
  APITypes.CreateDefaultAddressMutation
>;
export const updateDefaultAddress = /* GraphQL */ `mutation UpdateDefaultAddress(
  $input: UpdateDefaultAddressInput!
  $condition: ModelDefaultAddressConditionInput
) {
  updateDefaultAddress(input: $input, condition: $condition) {
    id
    companyId
    userId
    status
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDefaultAddressMutationVariables,
  APITypes.UpdateDefaultAddressMutation
>;
export const deleteDefaultAddress = /* GraphQL */ `mutation DeleteDefaultAddress(
  $input: DeleteDefaultAddressInput!
  $condition: ModelDefaultAddressConditionInput
) {
  deleteDefaultAddress(input: $input, condition: $condition) {
    id
    companyId
    userId
    status
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDefaultAddressMutationVariables,
  APITypes.DeleteDefaultAddressMutation
>;
export const createDefaultDeliveryContact = /* GraphQL */ `mutation CreateDefaultDeliveryContact(
  $input: CreateDefaultDeliveryContactInput!
  $condition: ModelDefaultDeliveryContactConditionInput
) {
  createDefaultDeliveryContact(input: $input, condition: $condition) {
    id
    companyId
    userId
    status
    name
    phoneNumber
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDefaultDeliveryContactMutationVariables,
  APITypes.CreateDefaultDeliveryContactMutation
>;
export const updateDefaultDeliveryContact = /* GraphQL */ `mutation UpdateDefaultDeliveryContact(
  $input: UpdateDefaultDeliveryContactInput!
  $condition: ModelDefaultDeliveryContactConditionInput
) {
  updateDefaultDeliveryContact(input: $input, condition: $condition) {
    id
    companyId
    userId
    status
    name
    phoneNumber
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDefaultDeliveryContactMutationVariables,
  APITypes.UpdateDefaultDeliveryContactMutation
>;
export const deleteDefaultDeliveryContact = /* GraphQL */ `mutation DeleteDefaultDeliveryContact(
  $input: DeleteDefaultDeliveryContactInput!
  $condition: ModelDefaultDeliveryContactConditionInput
) {
  deleteDefaultDeliveryContact(input: $input, condition: $condition) {
    id
    companyId
    userId
    status
    name
    phoneNumber
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDefaultDeliveryContactMutationVariables,
  APITypes.DeleteDefaultDeliveryContactMutation
>;
export const createPopCategories = /* GraphQL */ `mutation CreatePopCategories(
  $input: CreatePopCategoriesInput!
  $condition: ModelPopCategoriesConditionInput
) {
  createPopCategories(input: $input, condition: $condition) {
    id
    materialId
    name
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePopCategoriesMutationVariables,
  APITypes.CreatePopCategoriesMutation
>;
export const updatePopCategories = /* GraphQL */ `mutation UpdatePopCategories(
  $input: UpdatePopCategoriesInput!
  $condition: ModelPopCategoriesConditionInput
) {
  updatePopCategories(input: $input, condition: $condition) {
    id
    materialId
    name
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePopCategoriesMutationVariables,
  APITypes.UpdatePopCategoriesMutation
>;
export const deletePopCategories = /* GraphQL */ `mutation DeletePopCategories(
  $input: DeletePopCategoriesInput!
  $condition: ModelPopCategoriesConditionInput
) {
  deletePopCategories(input: $input, condition: $condition) {
    id
    materialId
    name
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePopCategoriesMutationVariables,
  APITypes.DeletePopCategoriesMutation
>;
export const createRfp = /* GraphQL */ `mutation CreateRfp(
  $input: CreateRfpInput!
  $condition: ModelRfpConditionInput
) {
  createRfp(input: $input, condition: $condition) {
    id
    clientId
    status
    name
    nombre
    requerimiento
    estatus
    descripcion
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    url
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        name
        description
        validity_days
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfp {
          id
          clientId
          status
          name
          nombre
          requerimiento
          estatus
          descripcion
          url
          limit_time
          creator
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        rfpProposalsRfpId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    creator
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRfpMutationVariables,
  APITypes.CreateRfpMutation
>;
export const updateRfp = /* GraphQL */ `mutation UpdateRfp(
  $input: UpdateRfpInput!
  $condition: ModelRfpConditionInput
) {
  updateRfp(input: $input, condition: $condition) {
    id
    clientId
    status
    name
    nombre
    requerimiento
    estatus
    descripcion
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    url
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        name
        description
        validity_days
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfp {
          id
          clientId
          status
          name
          nombre
          requerimiento
          estatus
          descripcion
          url
          limit_time
          creator
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        rfpProposalsRfpId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    creator
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRfpMutationVariables,
  APITypes.UpdateRfpMutation
>;
export const deleteRfp = /* GraphQL */ `mutation DeleteRfp(
  $input: DeleteRfpInput!
  $condition: ModelRfpConditionInput
) {
  deleteRfp(input: $input, condition: $condition) {
    id
    clientId
    status
    name
    nombre
    requerimiento
    estatus
    descripcion
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    url
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        name
        description
        validity_days
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfp {
          id
          clientId
          status
          name
          nombre
          requerimiento
          estatus
          descripcion
          url
          limit_time
          creator
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        rfpProposalsRfpId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    creator
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRfpMutationVariables,
  APITypes.DeleteRfpMutation
>;
export const createRfpProposals = /* GraphQL */ `mutation CreateRfpProposals(
  $input: CreateRfpProposalsInput!
  $condition: ModelRfpProposalsConditionInput
) {
  createRfpProposals(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    name
    description
    validity_days
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfp {
      id
      clientId
      status
      name
      nombre
      requerimiento
      estatus
      descripcion
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      url
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          name
          description
          validity_days
          created
          updated
          multipleProducts
          hidden
          rfpProposalsRfpId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      creator
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    rfpProposalsRfpId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRfpProposalsMutationVariables,
  APITypes.CreateRfpProposalsMutation
>;
export const updateRfpProposals = /* GraphQL */ `mutation UpdateRfpProposals(
  $input: UpdateRfpProposalsInput!
  $condition: ModelRfpProposalsConditionInput
) {
  updateRfpProposals(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    name
    description
    validity_days
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfp {
      id
      clientId
      status
      name
      nombre
      requerimiento
      estatus
      descripcion
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      url
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          name
          description
          validity_days
          created
          updated
          multipleProducts
          hidden
          rfpProposalsRfpId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      creator
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    rfpProposalsRfpId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRfpProposalsMutationVariables,
  APITypes.UpdateRfpProposalsMutation
>;
export const deleteRfpProposals = /* GraphQL */ `mutation DeleteRfpProposals(
  $input: DeleteRfpProposalsInput!
  $condition: ModelRfpProposalsConditionInput
) {
  deleteRfpProposals(input: $input, condition: $condition) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    name
    description
    validity_days
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfp {
      id
      clientId
      status
      name
      nombre
      requerimiento
      estatus
      descripcion
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      url
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          name
          description
          validity_days
          created
          updated
          multipleProducts
          hidden
          rfpProposalsRfpId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      creator
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    rfpProposalsRfpId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRfpProposalsMutationVariables,
  APITypes.DeleteRfpProposalsMutation
>;
export const createEvaluationProviders = /* GraphQL */ `mutation CreateEvaluationProviders(
  $input: CreateEvaluationProvidersInput!
  $condition: ModelEvaluationProvidersConditionInput
) {
  createEvaluationProviders(input: $input, condition: $condition) {
    id
    providerId
    creratorId
    orderId
    time
    price
    quality
    att
    comments
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEvaluationProvidersMutationVariables,
  APITypes.CreateEvaluationProvidersMutation
>;
export const updateEvaluationProviders = /* GraphQL */ `mutation UpdateEvaluationProviders(
  $input: UpdateEvaluationProvidersInput!
  $condition: ModelEvaluationProvidersConditionInput
) {
  updateEvaluationProviders(input: $input, condition: $condition) {
    id
    providerId
    creratorId
    orderId
    time
    price
    quality
    att
    comments
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEvaluationProvidersMutationVariables,
  APITypes.UpdateEvaluationProvidersMutation
>;
export const deleteEvaluationProviders = /* GraphQL */ `mutation DeleteEvaluationProviders(
  $input: DeleteEvaluationProvidersInput!
  $condition: ModelEvaluationProvidersConditionInput
) {
  deleteEvaluationProviders(input: $input, condition: $condition) {
    id
    providerId
    creratorId
    orderId
    time
    price
    quality
    att
    comments
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEvaluationProvidersMutationVariables,
  APITypes.DeleteEvaluationProvidersMutation
>;
export const createLogProduct = /* GraphQL */ `mutation CreateLogProduct(
  $input: CreateLogProductInput!
  $condition: ModelLogProductConditionInput
) {
  createLogProduct(input: $input, condition: $condition) {
    id
    status
    creator
    created
    productId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogProductMutationVariables,
  APITypes.CreateLogProductMutation
>;
export const updateLogProduct = /* GraphQL */ `mutation UpdateLogProduct(
  $input: UpdateLogProductInput!
  $condition: ModelLogProductConditionInput
) {
  updateLogProduct(input: $input, condition: $condition) {
    id
    status
    creator
    created
    productId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogProductMutationVariables,
  APITypes.UpdateLogProductMutation
>;
export const deleteLogProduct = /* GraphQL */ `mutation DeleteLogProduct(
  $input: DeleteLogProductInput!
  $condition: ModelLogProductConditionInput
) {
  deleteLogProduct(input: $input, condition: $condition) {
    id
    status
    creator
    created
    productId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogProductMutationVariables,
  APITypes.DeleteLogProductMutation
>;
export const createLogCategory = /* GraphQL */ `mutation CreateLogCategory(
  $input: CreateLogCategoryInput!
  $condition: ModelLogCategoryConditionInput
) {
  createLogCategory(input: $input, condition: $condition) {
    id
    status
    creator
    created
    categoryId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogCategoryMutationVariables,
  APITypes.CreateLogCategoryMutation
>;
export const updateLogCategory = /* GraphQL */ `mutation UpdateLogCategory(
  $input: UpdateLogCategoryInput!
  $condition: ModelLogCategoryConditionInput
) {
  updateLogCategory(input: $input, condition: $condition) {
    id
    status
    creator
    created
    categoryId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogCategoryMutationVariables,
  APITypes.UpdateLogCategoryMutation
>;
export const deleteLogCategory = /* GraphQL */ `mutation DeleteLogCategory(
  $input: DeleteLogCategoryInput!
  $condition: ModelLogCategoryConditionInput
) {
  deleteLogCategory(input: $input, condition: $condition) {
    id
    status
    creator
    created
    categoryId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogCategoryMutationVariables,
  APITypes.DeleteLogCategoryMutation
>;
export const createLogRfq = /* GraphQL */ `mutation CreateLogRfq(
  $input: CreateLogRfqInput!
  $condition: ModelLogRfqConditionInput
) {
  createLogRfq(input: $input, condition: $condition) {
    id
    status
    creator
    rfqId
    description
    provider_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogRfqMutationVariables,
  APITypes.CreateLogRfqMutation
>;
export const updateLogRfq = /* GraphQL */ `mutation UpdateLogRfq(
  $input: UpdateLogRfqInput!
  $condition: ModelLogRfqConditionInput
) {
  updateLogRfq(input: $input, condition: $condition) {
    id
    status
    creator
    rfqId
    description
    provider_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogRfqMutationVariables,
  APITypes.UpdateLogRfqMutation
>;
export const deleteLogRfq = /* GraphQL */ `mutation DeleteLogRfq(
  $input: DeleteLogRfqInput!
  $condition: ModelLogRfqConditionInput
) {
  deleteLogRfq(input: $input, condition: $condition) {
    id
    status
    creator
    rfqId
    description
    provider_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogRfqMutationVariables,
  APITypes.DeleteLogRfqMutation
>;
export const createLogProductLabel = /* GraphQL */ `mutation CreateLogProductLabel(
  $input: CreateLogProductLabelInput!
  $condition: ModelLogProductLabelConditionInput
) {
  createLogProductLabel(input: $input, condition: $condition) {
    id
    status
    creator
    created
    productLabelId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogProductLabelMutationVariables,
  APITypes.CreateLogProductLabelMutation
>;
export const updateLogProductLabel = /* GraphQL */ `mutation UpdateLogProductLabel(
  $input: UpdateLogProductLabelInput!
  $condition: ModelLogProductLabelConditionInput
) {
  updateLogProductLabel(input: $input, condition: $condition) {
    id
    status
    creator
    created
    productLabelId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogProductLabelMutationVariables,
  APITypes.UpdateLogProductLabelMutation
>;
export const deleteLogProductLabel = /* GraphQL */ `mutation DeleteLogProductLabel(
  $input: DeleteLogProductLabelInput!
  $condition: ModelLogProductLabelConditionInput
) {
  deleteLogProductLabel(input: $input, condition: $condition) {
    id
    status
    creator
    created
    productLabelId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogProductLabelMutationVariables,
  APITypes.DeleteLogProductLabelMutation
>;
export const createNotification = /* GraphQL */ `mutation CreateNotification(
  $input: CreateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  createNotification(input: $input, condition: $condition) {
    id
    type
    remember
    stared
    important
    status
    isChat
    creatorName
    creatorEmail
    creatorRole
    creatorId
    receipentName
    receipentRole
    receipentEmail
    receipentId
    showPopUp
    sendEmail
    title
    subtitle
    description
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    path
    idParent
    createdAt
    seenAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotificationMutationVariables,
  APITypes.CreateNotificationMutation
>;
export const updateNotification = /* GraphQL */ `mutation UpdateNotification(
  $input: UpdateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  updateNotification(input: $input, condition: $condition) {
    id
    type
    remember
    stared
    important
    status
    isChat
    creatorName
    creatorEmail
    creatorRole
    creatorId
    receipentName
    receipentRole
    receipentEmail
    receipentId
    showPopUp
    sendEmail
    title
    subtitle
    description
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    path
    idParent
    createdAt
    seenAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNotificationMutationVariables,
  APITypes.UpdateNotificationMutation
>;
export const deleteNotification = /* GraphQL */ `mutation DeleteNotification(
  $input: DeleteNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  deleteNotification(input: $input, condition: $condition) {
    id
    type
    remember
    stared
    important
    status
    isChat
    creatorName
    creatorEmail
    creatorRole
    creatorId
    receipentName
    receipentRole
    receipentEmail
    receipentId
    showPopUp
    sendEmail
    title
    subtitle
    description
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    path
    idParent
    createdAt
    seenAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNotificationMutationVariables,
  APITypes.DeleteNotificationMutation
>;
export const createMercadoCategories = /* GraphQL */ `mutation CreateMercadoCategories(
  $input: CreateMercadoCategoriesInput!
  $condition: ModelMercadoCategoriesConditionInput
) {
  createMercadoCategories(input: $input, condition: $condition) {
    id
    idMercado
    status
    name
    rulesClients {
      clientID
      enabled
      isUnrestricted
      isRestricted
      increment
      fee
      __typename
    }
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    parentCategory
    childrenCategories
    items
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMercadoCategoriesMutationVariables,
  APITypes.CreateMercadoCategoriesMutation
>;
export const updateMercadoCategories = /* GraphQL */ `mutation UpdateMercadoCategories(
  $input: UpdateMercadoCategoriesInput!
  $condition: ModelMercadoCategoriesConditionInput
) {
  updateMercadoCategories(input: $input, condition: $condition) {
    id
    idMercado
    status
    name
    rulesClients {
      clientID
      enabled
      isUnrestricted
      isRestricted
      increment
      fee
      __typename
    }
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    parentCategory
    childrenCategories
    items
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMercadoCategoriesMutationVariables,
  APITypes.UpdateMercadoCategoriesMutation
>;
export const deleteMercadoCategories = /* GraphQL */ `mutation DeleteMercadoCategories(
  $input: DeleteMercadoCategoriesInput!
  $condition: ModelMercadoCategoriesConditionInput
) {
  deleteMercadoCategories(input: $input, condition: $condition) {
    id
    idMercado
    status
    name
    rulesClients {
      clientID
      enabled
      isUnrestricted
      isRestricted
      increment
      fee
      __typename
    }
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    parentCategory
    childrenCategories
    items
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMercadoCategoriesMutationVariables,
  APITypes.DeleteMercadoCategoriesMutation
>;
export const createMercadoProductCategoryClient = /* GraphQL */ `mutation CreateMercadoProductCategoryClient(
  $input: CreateMercadoProductCategoryClientInput!
  $condition: ModelMercadoProductCategoryClientConditionInput
) {
  createMercadoProductCategoryClient(input: $input, condition: $condition) {
    id
    idClient
    idMercadoCategory
    unrestrictedProducts
    restrictedProducts
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMercadoProductCategoryClientMutationVariables,
  APITypes.CreateMercadoProductCategoryClientMutation
>;
export const updateMercadoProductCategoryClient = /* GraphQL */ `mutation UpdateMercadoProductCategoryClient(
  $input: UpdateMercadoProductCategoryClientInput!
  $condition: ModelMercadoProductCategoryClientConditionInput
) {
  updateMercadoProductCategoryClient(input: $input, condition: $condition) {
    id
    idClient
    idMercadoCategory
    unrestrictedProducts
    restrictedProducts
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMercadoProductCategoryClientMutationVariables,
  APITypes.UpdateMercadoProductCategoryClientMutation
>;
export const deleteMercadoProductCategoryClient = /* GraphQL */ `mutation DeleteMercadoProductCategoryClient(
  $input: DeleteMercadoProductCategoryClientInput!
  $condition: ModelMercadoProductCategoryClientConditionInput
) {
  deleteMercadoProductCategoryClient(input: $input, condition: $condition) {
    id
    idClient
    idMercadoCategory
    unrestrictedProducts
    restrictedProducts
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMercadoProductCategoryClientMutationVariables,
  APITypes.DeleteMercadoProductCategoryClientMutation
>;
export const createBigSmartStatus = /* GraphQL */ `mutation CreateBigSmartStatus(
  $input: CreateBigSmartStatusInput!
  $condition: ModelBigSmartStatusConditionInput
) {
  createBigSmartStatus(input: $input, condition: $condition) {
    id
    idStatus
    activity
    code
    status
    code_type
    description
    notification_content
    notification_subject
    custom
    clientsConfiguration {
      clientId
      contractor_notification
      agent_notification
      marketing_admin_notification
      admin_notification
      logistic_notification
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBigSmartStatusMutationVariables,
  APITypes.CreateBigSmartStatusMutation
>;
export const updateBigSmartStatus = /* GraphQL */ `mutation UpdateBigSmartStatus(
  $input: UpdateBigSmartStatusInput!
  $condition: ModelBigSmartStatusConditionInput
) {
  updateBigSmartStatus(input: $input, condition: $condition) {
    id
    idStatus
    activity
    code
    status
    code_type
    description
    notification_content
    notification_subject
    custom
    clientsConfiguration {
      clientId
      contractor_notification
      agent_notification
      marketing_admin_notification
      admin_notification
      logistic_notification
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBigSmartStatusMutationVariables,
  APITypes.UpdateBigSmartStatusMutation
>;
export const deleteBigSmartStatus = /* GraphQL */ `mutation DeleteBigSmartStatus(
  $input: DeleteBigSmartStatusInput!
  $condition: ModelBigSmartStatusConditionInput
) {
  deleteBigSmartStatus(input: $input, condition: $condition) {
    id
    idStatus
    activity
    code
    status
    code_type
    description
    notification_content
    notification_subject
    custom
    clientsConfiguration {
      clientId
      contractor_notification
      agent_notification
      marketing_admin_notification
      admin_notification
      logistic_notification
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBigSmartStatusMutationVariables,
  APITypes.DeleteBigSmartStatusMutation
>;
export const createBigSmartLogs = /* GraphQL */ `mutation CreateBigSmartLogs(
  $input: CreateBigSmartLogsInput!
  $condition: ModelBigSmartLogsConditionInput
) {
  createBigSmartLogs(input: $input, condition: $condition) {
    id
    orderId
    premiumOrderId
    clientId
    creator
    creator_email
    notification_subject
    notification_content
    tracking_number
    purchase_order_number
    code
    already_sent
    sent_at
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBigSmartLogsMutationVariables,
  APITypes.CreateBigSmartLogsMutation
>;
export const updateBigSmartLogs = /* GraphQL */ `mutation UpdateBigSmartLogs(
  $input: UpdateBigSmartLogsInput!
  $condition: ModelBigSmartLogsConditionInput
) {
  updateBigSmartLogs(input: $input, condition: $condition) {
    id
    orderId
    premiumOrderId
    clientId
    creator
    creator_email
    notification_subject
    notification_content
    tracking_number
    purchase_order_number
    code
    already_sent
    sent_at
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBigSmartLogsMutationVariables,
  APITypes.UpdateBigSmartLogsMutation
>;
export const deleteBigSmartLogs = /* GraphQL */ `mutation DeleteBigSmartLogs(
  $input: DeleteBigSmartLogsInput!
  $condition: ModelBigSmartLogsConditionInput
) {
  deleteBigSmartLogs(input: $input, condition: $condition) {
    id
    orderId
    premiumOrderId
    clientId
    creator
    creator_email
    notification_subject
    notification_content
    tracking_number
    purchase_order_number
    code
    already_sent
    sent_at
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBigSmartLogsMutationVariables,
  APITypes.DeleteBigSmartLogsMutation
>;
export const createExternalApis = /* GraphQL */ `mutation CreateExternalApis(
  $input: CreateExternalApisInput!
  $condition: ModelExternalApisConditionInput
) {
  createExternalApis(input: $input, condition: $condition) {
    id
    status
    name
    nameExternal
    region
    increment
    discount
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateExternalApisMutationVariables,
  APITypes.CreateExternalApisMutation
>;
export const updateExternalApis = /* GraphQL */ `mutation UpdateExternalApis(
  $input: UpdateExternalApisInput!
  $condition: ModelExternalApisConditionInput
) {
  updateExternalApis(input: $input, condition: $condition) {
    id
    status
    name
    nameExternal
    region
    increment
    discount
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateExternalApisMutationVariables,
  APITypes.UpdateExternalApisMutation
>;
export const deleteExternalApis = /* GraphQL */ `mutation DeleteExternalApis(
  $input: DeleteExternalApisInput!
  $condition: ModelExternalApisConditionInput
) {
  deleteExternalApis(input: $input, condition: $condition) {
    id
    status
    name
    nameExternal
    region
    increment
    discount
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteExternalApisMutationVariables,
  APITypes.DeleteExternalApisMutation
>;
export const createLogExternalApis = /* GraphQL */ `mutation CreateLogExternalApis(
  $input: CreateLogExternalApisInput!
  $condition: ModelLogExternalApisConditionInput
) {
  createLogExternalApis(input: $input, condition: $condition) {
    id
    status
    creator
    apiId
    description
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogExternalApisMutationVariables,
  APITypes.CreateLogExternalApisMutation
>;
export const updateLogExternalApis = /* GraphQL */ `mutation UpdateLogExternalApis(
  $input: UpdateLogExternalApisInput!
  $condition: ModelLogExternalApisConditionInput
) {
  updateLogExternalApis(input: $input, condition: $condition) {
    id
    status
    creator
    apiId
    description
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogExternalApisMutationVariables,
  APITypes.UpdateLogExternalApisMutation
>;
export const deleteLogExternalApis = /* GraphQL */ `mutation DeleteLogExternalApis(
  $input: DeleteLogExternalApisInput!
  $condition: ModelLogExternalApisConditionInput
) {
  deleteLogExternalApis(input: $input, condition: $condition) {
    id
    status
    creator
    apiId
    description
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogExternalApisMutationVariables,
  APITypes.DeleteLogExternalApisMutation
>;
export const createPrintPrices = /* GraphQL */ `mutation CreatePrintPrices(
  $input: CreatePrintPricesInput!
  $condition: ModelPrintPricesConditionInput
) {
  createPrintPrices(input: $input, condition: $condition) {
    id
    identifier
    status
    creator
    description
    price
    minUnits
    maxUnits
    ranges {
      price
      minUnits
      maxUnits
      __typename
    }
    clientPrintPrices {
      clientId
      price
      minUnits
      maxUnits
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrintPricesMutationVariables,
  APITypes.CreatePrintPricesMutation
>;
export const updatePrintPrices = /* GraphQL */ `mutation UpdatePrintPrices(
  $input: UpdatePrintPricesInput!
  $condition: ModelPrintPricesConditionInput
) {
  updatePrintPrices(input: $input, condition: $condition) {
    id
    identifier
    status
    creator
    description
    price
    minUnits
    maxUnits
    ranges {
      price
      minUnits
      maxUnits
      __typename
    }
    clientPrintPrices {
      clientId
      price
      minUnits
      maxUnits
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrintPricesMutationVariables,
  APITypes.UpdatePrintPricesMutation
>;
export const deletePrintPrices = /* GraphQL */ `mutation DeletePrintPrices(
  $input: DeletePrintPricesInput!
  $condition: ModelPrintPricesConditionInput
) {
  deletePrintPrices(input: $input, condition: $condition) {
    id
    identifier
    status
    creator
    description
    price
    minUnits
    maxUnits
    ranges {
      price
      minUnits
      maxUnits
      __typename
    }
    clientPrintPrices {
      clientId
      price
      minUnits
      maxUnits
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrintPricesMutationVariables,
  APITypes.DeletePrintPricesMutation
>;
export const createLogPrintPrices = /* GraphQL */ `mutation CreateLogPrintPrices(
  $input: CreateLogPrintPricesInput!
  $condition: ModelLogPrintPricesConditionInput
) {
  createLogPrintPrices(input: $input, condition: $condition) {
    id
    status
    creator
    printPriceId
    description
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogPrintPricesMutationVariables,
  APITypes.CreateLogPrintPricesMutation
>;
export const updateLogPrintPrices = /* GraphQL */ `mutation UpdateLogPrintPrices(
  $input: UpdateLogPrintPricesInput!
  $condition: ModelLogPrintPricesConditionInput
) {
  updateLogPrintPrices(input: $input, condition: $condition) {
    id
    status
    creator
    printPriceId
    description
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogPrintPricesMutationVariables,
  APITypes.UpdateLogPrintPricesMutation
>;
export const deleteLogPrintPrices = /* GraphQL */ `mutation DeleteLogPrintPrices(
  $input: DeleteLogPrintPricesInput!
  $condition: ModelLogPrintPricesConditionInput
) {
  deleteLogPrintPrices(input: $input, condition: $condition) {
    id
    status
    creator
    printPriceId
    description
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogPrintPricesMutationVariables,
  APITypes.DeleteLogPrintPricesMutation
>;
export const createPrintLogos = /* GraphQL */ `mutation CreatePrintLogos(
  $input: CreatePrintLogosInput!
  $condition: ModelPrintLogosConditionInput
) {
  createPrintLogos(input: $input, condition: $condition) {
    id
    status
    creator
    description
    identifier
    clientId
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrintLogosMutationVariables,
  APITypes.CreatePrintLogosMutation
>;
export const updatePrintLogos = /* GraphQL */ `mutation UpdatePrintLogos(
  $input: UpdatePrintLogosInput!
  $condition: ModelPrintLogosConditionInput
) {
  updatePrintLogos(input: $input, condition: $condition) {
    id
    status
    creator
    description
    identifier
    clientId
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrintLogosMutationVariables,
  APITypes.UpdatePrintLogosMutation
>;
export const deletePrintLogos = /* GraphQL */ `mutation DeletePrintLogos(
  $input: DeletePrintLogosInput!
  $condition: ModelPrintLogosConditionInput
) {
  deletePrintLogos(input: $input, condition: $condition) {
    id
    status
    creator
    description
    identifier
    clientId
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrintLogosMutationVariables,
  APITypes.DeletePrintLogosMutation
>;
export const createLogisticPostalCode = /* GraphQL */ `mutation CreateLogisticPostalCode(
  $input: CreateLogisticPostalCodeInput!
  $condition: ModelLogisticPostalCodeConditionInput
) {
  createLogisticPostalCode(input: $input, condition: $condition) {
    id
    cpFrom
    cpTo
    zone
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogisticPostalCodeMutationVariables,
  APITypes.CreateLogisticPostalCodeMutation
>;
export const updateLogisticPostalCode = /* GraphQL */ `mutation UpdateLogisticPostalCode(
  $input: UpdateLogisticPostalCodeInput!
  $condition: ModelLogisticPostalCodeConditionInput
) {
  updateLogisticPostalCode(input: $input, condition: $condition) {
    id
    cpFrom
    cpTo
    zone
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogisticPostalCodeMutationVariables,
  APITypes.UpdateLogisticPostalCodeMutation
>;
export const deleteLogisticPostalCode = /* GraphQL */ `mutation DeleteLogisticPostalCode(
  $input: DeleteLogisticPostalCodeInput!
  $condition: ModelLogisticPostalCodeConditionInput
) {
  deleteLogisticPostalCode(input: $input, condition: $condition) {
    id
    cpFrom
    cpTo
    zone
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogisticPostalCodeMutationVariables,
  APITypes.DeleteLogisticPostalCodeMutation
>;
export const createLogisticPieceRange = /* GraphQL */ `mutation CreateLogisticPieceRange(
  $input: CreateLogisticPieceRangeInput!
  $condition: ModelLogisticPieceRangeConditionInput
) {
  createLogisticPieceRange(input: $input, condition: $condition) {
    id
    piecesRange
    min
    max
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogisticPieceRangeMutationVariables,
  APITypes.CreateLogisticPieceRangeMutation
>;
export const updateLogisticPieceRange = /* GraphQL */ `mutation UpdateLogisticPieceRange(
  $input: UpdateLogisticPieceRangeInput!
  $condition: ModelLogisticPieceRangeConditionInput
) {
  updateLogisticPieceRange(input: $input, condition: $condition) {
    id
    piecesRange
    min
    max
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogisticPieceRangeMutationVariables,
  APITypes.UpdateLogisticPieceRangeMutation
>;
export const deleteLogisticPieceRange = /* GraphQL */ `mutation DeleteLogisticPieceRange(
  $input: DeleteLogisticPieceRangeInput!
  $condition: ModelLogisticPieceRangeConditionInput
) {
  deleteLogisticPieceRange(input: $input, condition: $condition) {
    id
    piecesRange
    min
    max
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogisticPieceRangeMutationVariables,
  APITypes.DeleteLogisticPieceRangeMutation
>;
export const createLogisticWeightRange = /* GraphQL */ `mutation CreateLogisticWeightRange(
  $input: CreateLogisticWeightRangeInput!
  $condition: ModelLogisticWeightRangeConditionInput
) {
  createLogisticWeightRange(input: $input, condition: $condition) {
    id
    weightRange
    min
    max
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogisticWeightRangeMutationVariables,
  APITypes.CreateLogisticWeightRangeMutation
>;
export const updateLogisticWeightRange = /* GraphQL */ `mutation UpdateLogisticWeightRange(
  $input: UpdateLogisticWeightRangeInput!
  $condition: ModelLogisticWeightRangeConditionInput
) {
  updateLogisticWeightRange(input: $input, condition: $condition) {
    id
    weightRange
    min
    max
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogisticWeightRangeMutationVariables,
  APITypes.UpdateLogisticWeightRangeMutation
>;
export const deleteLogisticWeightRange = /* GraphQL */ `mutation DeleteLogisticWeightRange(
  $input: DeleteLogisticWeightRangeInput!
  $condition: ModelLogisticWeightRangeConditionInput
) {
  deleteLogisticWeightRange(input: $input, condition: $condition) {
    id
    weightRange
    min
    max
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogisticWeightRangeMutationVariables,
  APITypes.DeleteLogisticWeightRangeMutation
>;
export const createLogisticWeightBox = /* GraphQL */ `mutation CreateLogisticWeightBox(
  $input: CreateLogisticWeightBoxInput!
  $condition: ModelLogisticWeightBoxConditionInput
) {
  createLogisticWeightBox(input: $input, condition: $condition) {
    id
    boxId
    shippingPrices {
      weightRangeId
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogisticWeightBoxMutationVariables,
  APITypes.CreateLogisticWeightBoxMutation
>;
export const updateLogisticWeightBox = /* GraphQL */ `mutation UpdateLogisticWeightBox(
  $input: UpdateLogisticWeightBoxInput!
  $condition: ModelLogisticWeightBoxConditionInput
) {
  updateLogisticWeightBox(input: $input, condition: $condition) {
    id
    boxId
    shippingPrices {
      weightRangeId
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogisticWeightBoxMutationVariables,
  APITypes.UpdateLogisticWeightBoxMutation
>;
export const deleteLogisticWeightBox = /* GraphQL */ `mutation DeleteLogisticWeightBox(
  $input: DeleteLogisticWeightBoxInput!
  $condition: ModelLogisticWeightBoxConditionInput
) {
  deleteLogisticWeightBox(input: $input, condition: $condition) {
    id
    boxId
    shippingPrices {
      weightRangeId
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogisticWeightBoxMutationVariables,
  APITypes.DeleteLogisticWeightBoxMutation
>;
export const createLogisticZone = /* GraphQL */ `mutation CreateLogisticZone(
  $input: CreateLogisticZoneInput!
  $condition: ModelLogisticZoneConditionInput
) {
  createLogisticZone(input: $input, condition: $condition) {
    id
    zoneName
    shippingPrices {
      piecesRangeId
      price
      __typename
    }
    clientsRanges {
      id
      clientId
      piecesRange
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogisticZoneMutationVariables,
  APITypes.CreateLogisticZoneMutation
>;
export const updateLogisticZone = /* GraphQL */ `mutation UpdateLogisticZone(
  $input: UpdateLogisticZoneInput!
  $condition: ModelLogisticZoneConditionInput
) {
  updateLogisticZone(input: $input, condition: $condition) {
    id
    zoneName
    shippingPrices {
      piecesRangeId
      price
      __typename
    }
    clientsRanges {
      id
      clientId
      piecesRange
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogisticZoneMutationVariables,
  APITypes.UpdateLogisticZoneMutation
>;
export const deleteLogisticZone = /* GraphQL */ `mutation DeleteLogisticZone(
  $input: DeleteLogisticZoneInput!
  $condition: ModelLogisticZoneConditionInput
) {
  deleteLogisticZone(input: $input, condition: $condition) {
    id
    zoneName
    shippingPrices {
      piecesRangeId
      price
      __typename
    }
    clientsRanges {
      id
      clientId
      piecesRange
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogisticZoneMutationVariables,
  APITypes.DeleteLogisticZoneMutation
>;
export const createLogisticBox = /* GraphQL */ `mutation CreateLogisticBox(
  $input: CreateLogisticBoxInput!
  $condition: ModelLogisticBoxConditionInput
) {
  createLogisticBox(input: $input, condition: $condition) {
    id
    status
    name
    description
    price
    width
    height
    depth
    volumetricWeight
    maxWeight
    maxPayload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogisticBoxMutationVariables,
  APITypes.CreateLogisticBoxMutation
>;
export const updateLogisticBox = /* GraphQL */ `mutation UpdateLogisticBox(
  $input: UpdateLogisticBoxInput!
  $condition: ModelLogisticBoxConditionInput
) {
  updateLogisticBox(input: $input, condition: $condition) {
    id
    status
    name
    description
    price
    width
    height
    depth
    volumetricWeight
    maxWeight
    maxPayload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogisticBoxMutationVariables,
  APITypes.UpdateLogisticBoxMutation
>;
export const deleteLogisticBox = /* GraphQL */ `mutation DeleteLogisticBox(
  $input: DeleteLogisticBoxInput!
  $condition: ModelLogisticBoxConditionInput
) {
  deleteLogisticBox(input: $input, condition: $condition) {
    id
    status
    name
    description
    price
    width
    height
    depth
    volumetricWeight
    maxWeight
    maxPayload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogisticBoxMutationVariables,
  APITypes.DeleteLogisticBoxMutation
>;
export const createLogisticVehicles = /* GraphQL */ `mutation CreateLogisticVehicles(
  $input: CreateLogisticVehiclesInput!
  $condition: ModelLogisticVehiclesConditionInput
) {
  createLogisticVehicles(input: $input, condition: $condition) {
    id
    status
    licensePlate
    hasInsurancePolicy
    fuelCapacity
    width
    height
    depth
    maxWeight
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogisticVehiclesMutationVariables,
  APITypes.CreateLogisticVehiclesMutation
>;
export const updateLogisticVehicles = /* GraphQL */ `mutation UpdateLogisticVehicles(
  $input: UpdateLogisticVehiclesInput!
  $condition: ModelLogisticVehiclesConditionInput
) {
  updateLogisticVehicles(input: $input, condition: $condition) {
    id
    status
    licensePlate
    hasInsurancePolicy
    fuelCapacity
    width
    height
    depth
    maxWeight
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogisticVehiclesMutationVariables,
  APITypes.UpdateLogisticVehiclesMutation
>;
export const deleteLogisticVehicles = /* GraphQL */ `mutation DeleteLogisticVehicles(
  $input: DeleteLogisticVehiclesInput!
  $condition: ModelLogisticVehiclesConditionInput
) {
  deleteLogisticVehicles(input: $input, condition: $condition) {
    id
    status
    licensePlate
    hasInsurancePolicy
    fuelCapacity
    width
    height
    depth
    maxWeight
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogisticVehiclesMutationVariables,
  APITypes.DeleteLogisticVehiclesMutation
>;
export const createAlendumClient = /* GraphQL */ `mutation CreateAlendumClient(
  $input: CreateAlendumClientInput!
  $condition: ModelAlendumClientConditionInput
) {
  createAlendumClient(input: $input, condition: $condition) {
    id
    bfClientId
    alendumClientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAlendumClientMutationVariables,
  APITypes.CreateAlendumClientMutation
>;
export const updateAlendumClient = /* GraphQL */ `mutation UpdateAlendumClient(
  $input: UpdateAlendumClientInput!
  $condition: ModelAlendumClientConditionInput
) {
  updateAlendumClient(input: $input, condition: $condition) {
    id
    bfClientId
    alendumClientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAlendumClientMutationVariables,
  APITypes.UpdateAlendumClientMutation
>;
export const deleteAlendumClient = /* GraphQL */ `mutation DeleteAlendumClient(
  $input: DeleteAlendumClientInput!
  $condition: ModelAlendumClientConditionInput
) {
  deleteAlendumClient(input: $input, condition: $condition) {
    id
    bfClientId
    alendumClientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAlendumClientMutationVariables,
  APITypes.DeleteAlendumClientMutation
>;
export const createAlendumCategory = /* GraphQL */ `mutation CreateAlendumCategory(
  $input: CreateAlendumCategoryInput!
  $condition: ModelAlendumCategoryConditionInput
) {
  createAlendumCategory(input: $input, condition: $condition) {
    id
    identifier
    position
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAlendumCategoryMutationVariables,
  APITypes.CreateAlendumCategoryMutation
>;
export const updateAlendumCategory = /* GraphQL */ `mutation UpdateAlendumCategory(
  $input: UpdateAlendumCategoryInput!
  $condition: ModelAlendumCategoryConditionInput
) {
  updateAlendumCategory(input: $input, condition: $condition) {
    id
    identifier
    position
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAlendumCategoryMutationVariables,
  APITypes.UpdateAlendumCategoryMutation
>;
export const deleteAlendumCategory = /* GraphQL */ `mutation DeleteAlendumCategory(
  $input: DeleteAlendumCategoryInput!
  $condition: ModelAlendumCategoryConditionInput
) {
  deleteAlendumCategory(input: $input, condition: $condition) {
    id
    identifier
    position
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAlendumCategoryMutationVariables,
  APITypes.DeleteAlendumCategoryMutation
>;
export const createAlendumBfCategory = /* GraphQL */ `mutation CreateAlendumBfCategory(
  $input: CreateAlendumBfCategoryInput!
  $condition: ModelAlendumBfCategoryConditionInput
) {
  createAlendumBfCategory(input: $input, condition: $condition) {
    id
    bfCategoryId
    alendumCategoryId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAlendumBfCategoryMutationVariables,
  APITypes.CreateAlendumBfCategoryMutation
>;
export const updateAlendumBfCategory = /* GraphQL */ `mutation UpdateAlendumBfCategory(
  $input: UpdateAlendumBfCategoryInput!
  $condition: ModelAlendumBfCategoryConditionInput
) {
  updateAlendumBfCategory(input: $input, condition: $condition) {
    id
    bfCategoryId
    alendumCategoryId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAlendumBfCategoryMutationVariables,
  APITypes.UpdateAlendumBfCategoryMutation
>;
export const deleteAlendumBfCategory = /* GraphQL */ `mutation DeleteAlendumBfCategory(
  $input: DeleteAlendumBfCategoryInput!
  $condition: ModelAlendumBfCategoryConditionInput
) {
  deleteAlendumBfCategory(input: $input, condition: $condition) {
    id
    bfCategoryId
    alendumCategoryId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAlendumBfCategoryMutationVariables,
  APITypes.DeleteAlendumBfCategoryMutation
>;
export const createAlendumBfProduct = /* GraphQL */ `mutation CreateAlendumBfProduct(
  $input: CreateAlendumBfProductInput!
  $condition: ModelAlendumBfProductConditionInput
) {
  createAlendumBfProduct(input: $input, condition: $condition) {
    id
    type
    status
    sku
    bfProductId
    alendumProductId
    alendumCategoryIdentifier
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAlendumBfProductMutationVariables,
  APITypes.CreateAlendumBfProductMutation
>;
export const updateAlendumBfProduct = /* GraphQL */ `mutation UpdateAlendumBfProduct(
  $input: UpdateAlendumBfProductInput!
  $condition: ModelAlendumBfProductConditionInput
) {
  updateAlendumBfProduct(input: $input, condition: $condition) {
    id
    type
    status
    sku
    bfProductId
    alendumProductId
    alendumCategoryIdentifier
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAlendumBfProductMutationVariables,
  APITypes.UpdateAlendumBfProductMutation
>;
export const deleteAlendumBfProduct = /* GraphQL */ `mutation DeleteAlendumBfProduct(
  $input: DeleteAlendumBfProductInput!
  $condition: ModelAlendumBfProductConditionInput
) {
  deleteAlendumBfProduct(input: $input, condition: $condition) {
    id
    type
    status
    sku
    bfProductId
    alendumProductId
    alendumCategoryIdentifier
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAlendumBfProductMutationVariables,
  APITypes.DeleteAlendumBfProductMutation
>;
export const createAlendumAddress = /* GraphQL */ `mutation CreateAlendumAddress(
  $input: CreateAlendumAddressInput!
  $condition: ModelAlendumAddressConditionInput
) {
  createAlendumAddress(input: $input, condition: $condition) {
    id
    bfAddressId
    alendumAddressId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAlendumAddressMutationVariables,
  APITypes.CreateAlendumAddressMutation
>;
export const updateAlendumAddress = /* GraphQL */ `mutation UpdateAlendumAddress(
  $input: UpdateAlendumAddressInput!
  $condition: ModelAlendumAddressConditionInput
) {
  updateAlendumAddress(input: $input, condition: $condition) {
    id
    bfAddressId
    alendumAddressId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAlendumAddressMutationVariables,
  APITypes.UpdateAlendumAddressMutation
>;
export const deleteAlendumAddress = /* GraphQL */ `mutation DeleteAlendumAddress(
  $input: DeleteAlendumAddressInput!
  $condition: ModelAlendumAddressConditionInput
) {
  deleteAlendumAddress(input: $input, condition: $condition) {
    id
    bfAddressId
    alendumAddressId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAlendumAddressMutationVariables,
  APITypes.DeleteAlendumAddressMutation
>;
export const createPakmailCarrier = /* GraphQL */ `mutation CreatePakmailCarrier(
  $input: CreatePakmailCarrierInput!
  $condition: ModelPakmailCarrierConditionInput
) {
  createPakmailCarrier(input: $input, condition: $condition) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePakmailCarrierMutationVariables,
  APITypes.CreatePakmailCarrierMutation
>;
export const updatePakmailCarrier = /* GraphQL */ `mutation UpdatePakmailCarrier(
  $input: UpdatePakmailCarrierInput!
  $condition: ModelPakmailCarrierConditionInput
) {
  updatePakmailCarrier(input: $input, condition: $condition) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePakmailCarrierMutationVariables,
  APITypes.UpdatePakmailCarrierMutation
>;
export const deletePakmailCarrier = /* GraphQL */ `mutation DeletePakmailCarrier(
  $input: DeletePakmailCarrierInput!
  $condition: ModelPakmailCarrierConditionInput
) {
  deletePakmailCarrier(input: $input, condition: $condition) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePakmailCarrierMutationVariables,
  APITypes.DeletePakmailCarrierMutation
>;
export const createLogPakmailCarrier = /* GraphQL */ `mutation CreateLogPakmailCarrier(
  $input: CreateLogPakmailCarrierInput!
  $condition: ModelLogPakmailCarrierConditionInput
) {
  createLogPakmailCarrier(input: $input, condition: $condition) {
    id
    creator
    pakmailCarrierId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogPakmailCarrierMutationVariables,
  APITypes.CreateLogPakmailCarrierMutation
>;
export const updateLogPakmailCarrier = /* GraphQL */ `mutation UpdateLogPakmailCarrier(
  $input: UpdateLogPakmailCarrierInput!
  $condition: ModelLogPakmailCarrierConditionInput
) {
  updateLogPakmailCarrier(input: $input, condition: $condition) {
    id
    creator
    pakmailCarrierId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogPakmailCarrierMutationVariables,
  APITypes.UpdateLogPakmailCarrierMutation
>;
export const deleteLogPakmailCarrier = /* GraphQL */ `mutation DeleteLogPakmailCarrier(
  $input: DeleteLogPakmailCarrierInput!
  $condition: ModelLogPakmailCarrierConditionInput
) {
  deleteLogPakmailCarrier(input: $input, condition: $condition) {
    id
    creator
    pakmailCarrierId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogPakmailCarrierMutationVariables,
  APITypes.DeleteLogPakmailCarrierMutation
>;
export const createPakmailService = /* GraphQL */ `mutation CreatePakmailService(
  $input: CreatePakmailServiceInput!
  $condition: ModelPakmailServiceConditionInput
) {
  createPakmailService(input: $input, condition: $condition) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    isNational
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePakmailServiceMutationVariables,
  APITypes.CreatePakmailServiceMutation
>;
export const updatePakmailService = /* GraphQL */ `mutation UpdatePakmailService(
  $input: UpdatePakmailServiceInput!
  $condition: ModelPakmailServiceConditionInput
) {
  updatePakmailService(input: $input, condition: $condition) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    isNational
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePakmailServiceMutationVariables,
  APITypes.UpdatePakmailServiceMutation
>;
export const deletePakmailService = /* GraphQL */ `mutation DeletePakmailService(
  $input: DeletePakmailServiceInput!
  $condition: ModelPakmailServiceConditionInput
) {
  deletePakmailService(input: $input, condition: $condition) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    isNational
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePakmailServiceMutationVariables,
  APITypes.DeletePakmailServiceMutation
>;
export const createPakmailShipmentStatus = /* GraphQL */ `mutation CreatePakmailShipmentStatus(
  $input: CreatePakmailShipmentStatusInput!
  $condition: ModelPakmailShipmentStatusConditionInput
) {
  createPakmailShipmentStatus(input: $input, condition: $condition) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePakmailShipmentStatusMutationVariables,
  APITypes.CreatePakmailShipmentStatusMutation
>;
export const updatePakmailShipmentStatus = /* GraphQL */ `mutation UpdatePakmailShipmentStatus(
  $input: UpdatePakmailShipmentStatusInput!
  $condition: ModelPakmailShipmentStatusConditionInput
) {
  updatePakmailShipmentStatus(input: $input, condition: $condition) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePakmailShipmentStatusMutationVariables,
  APITypes.UpdatePakmailShipmentStatusMutation
>;
export const deletePakmailShipmentStatus = /* GraphQL */ `mutation DeletePakmailShipmentStatus(
  $input: DeletePakmailShipmentStatusInput!
  $condition: ModelPakmailShipmentStatusConditionInput
) {
  deletePakmailShipmentStatus(input: $input, condition: $condition) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePakmailShipmentStatusMutationVariables,
  APITypes.DeletePakmailShipmentStatusMutation
>;
export const createPakmailShipmentEvent = /* GraphQL */ `mutation CreatePakmailShipmentEvent(
  $input: CreatePakmailShipmentEventInput!
  $condition: ModelPakmailShipmentEventConditionInput
) {
  createPakmailShipmentEvent(input: $input, condition: $condition) {
    id
    status
    identifier
    visibleFor
    color
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePakmailShipmentEventMutationVariables,
  APITypes.CreatePakmailShipmentEventMutation
>;
export const updatePakmailShipmentEvent = /* GraphQL */ `mutation UpdatePakmailShipmentEvent(
  $input: UpdatePakmailShipmentEventInput!
  $condition: ModelPakmailShipmentEventConditionInput
) {
  updatePakmailShipmentEvent(input: $input, condition: $condition) {
    id
    status
    identifier
    visibleFor
    color
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePakmailShipmentEventMutationVariables,
  APITypes.UpdatePakmailShipmentEventMutation
>;
export const deletePakmailShipmentEvent = /* GraphQL */ `mutation DeletePakmailShipmentEvent(
  $input: DeletePakmailShipmentEventInput!
  $condition: ModelPakmailShipmentEventConditionInput
) {
  deletePakmailShipmentEvent(input: $input, condition: $condition) {
    id
    status
    identifier
    visibleFor
    color
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePakmailShipmentEventMutationVariables,
  APITypes.DeletePakmailShipmentEventMutation
>;
export const createPakmailPickupStatus = /* GraphQL */ `mutation CreatePakmailPickupStatus(
  $input: CreatePakmailPickupStatusInput!
  $condition: ModelPakmailPickupStatusConditionInput
) {
  createPakmailPickupStatus(input: $input, condition: $condition) {
    id
    status
    identifier
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePakmailPickupStatusMutationVariables,
  APITypes.CreatePakmailPickupStatusMutation
>;
export const updatePakmailPickupStatus = /* GraphQL */ `mutation UpdatePakmailPickupStatus(
  $input: UpdatePakmailPickupStatusInput!
  $condition: ModelPakmailPickupStatusConditionInput
) {
  updatePakmailPickupStatus(input: $input, condition: $condition) {
    id
    status
    identifier
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePakmailPickupStatusMutationVariables,
  APITypes.UpdatePakmailPickupStatusMutation
>;
export const deletePakmailPickupStatus = /* GraphQL */ `mutation DeletePakmailPickupStatus(
  $input: DeletePakmailPickupStatusInput!
  $condition: ModelPakmailPickupStatusConditionInput
) {
  deletePakmailPickupStatus(input: $input, condition: $condition) {
    id
    status
    identifier
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePakmailPickupStatusMutationVariables,
  APITypes.DeletePakmailPickupStatusMutation
>;
export const createPremiumOrderLogisticGuide = /* GraphQL */ `mutation CreatePremiumOrderLogisticGuide(
  $input: CreatePremiumOrderLogisticGuideInput!
  $condition: ModelPremiumOrderLogisticGuideConditionInput
) {
  createPremiumOrderLogisticGuide(input: $input, condition: $condition) {
    id
    type
    pakmailId
    premiumOrderId
    clientId
    creatorId
    originAddressId
    destinationAddressId
    originAddress
    destinationAddress
    products {
      indexProduct
      productId
      quantity
      unitWidth
      unitHeight
      unitDepth
      unitWeight
      __typename
    }
    price
    increment
    fee
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePremiumOrderLogisticGuideMutationVariables,
  APITypes.CreatePremiumOrderLogisticGuideMutation
>;
export const updatePremiumOrderLogisticGuide = /* GraphQL */ `mutation UpdatePremiumOrderLogisticGuide(
  $input: UpdatePremiumOrderLogisticGuideInput!
  $condition: ModelPremiumOrderLogisticGuideConditionInput
) {
  updatePremiumOrderLogisticGuide(input: $input, condition: $condition) {
    id
    type
    pakmailId
    premiumOrderId
    clientId
    creatorId
    originAddressId
    destinationAddressId
    originAddress
    destinationAddress
    products {
      indexProduct
      productId
      quantity
      unitWidth
      unitHeight
      unitDepth
      unitWeight
      __typename
    }
    price
    increment
    fee
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePremiumOrderLogisticGuideMutationVariables,
  APITypes.UpdatePremiumOrderLogisticGuideMutation
>;
export const deletePremiumOrderLogisticGuide = /* GraphQL */ `mutation DeletePremiumOrderLogisticGuide(
  $input: DeletePremiumOrderLogisticGuideInput!
  $condition: ModelPremiumOrderLogisticGuideConditionInput
) {
  deletePremiumOrderLogisticGuide(input: $input, condition: $condition) {
    id
    type
    pakmailId
    premiumOrderId
    clientId
    creatorId
    originAddressId
    destinationAddressId
    originAddress
    destinationAddress
    products {
      indexProduct
      productId
      quantity
      unitWidth
      unitHeight
      unitDepth
      unitWeight
      __typename
    }
    price
    increment
    fee
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePremiumOrderLogisticGuideMutationVariables,
  APITypes.DeletePremiumOrderLogisticGuideMutation
>;
export const createProductLabelItem = /* GraphQL */ `mutation CreateProductLabelItem(
  $input: CreateProductLabelItemInput!
  $condition: ModelProductLabelItemConditionInput
) {
  createProductLabelItem(input: $input, condition: $condition) {
    id
    productId
    productLabelId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductLabelItemMutationVariables,
  APITypes.CreateProductLabelItemMutation
>;
export const updateProductLabelItem = /* GraphQL */ `mutation UpdateProductLabelItem(
  $input: UpdateProductLabelItemInput!
  $condition: ModelProductLabelItemConditionInput
) {
  updateProductLabelItem(input: $input, condition: $condition) {
    id
    productId
    productLabelId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductLabelItemMutationVariables,
  APITypes.UpdateProductLabelItemMutation
>;
export const deleteProductLabelItem = /* GraphQL */ `mutation DeleteProductLabelItem(
  $input: DeleteProductLabelItemInput!
  $condition: ModelProductLabelItemConditionInput
) {
  deleteProductLabelItem(input: $input, condition: $condition) {
    id
    productId
    productLabelId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductLabelItemMutationVariables,
  APITypes.DeleteProductLabelItemMutation
>;
export const createProductLabel = /* GraphQL */ `mutation CreateProductLabel(
  $input: CreateProductLabelInput!
  $condition: ModelProductLabelConditionInput
) {
  createProductLabel(input: $input, condition: $condition) {
    id
    name
    translation
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductLabelMutationVariables,
  APITypes.CreateProductLabelMutation
>;
export const updateProductLabel = /* GraphQL */ `mutation UpdateProductLabel(
  $input: UpdateProductLabelInput!
  $condition: ModelProductLabelConditionInput
) {
  updateProductLabel(input: $input, condition: $condition) {
    id
    name
    translation
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductLabelMutationVariables,
  APITypes.UpdateProductLabelMutation
>;
export const deleteProductLabel = /* GraphQL */ `mutation DeleteProductLabel(
  $input: DeleteProductLabelInput!
  $condition: ModelProductLabelConditionInput
) {
  deleteProductLabel(input: $input, condition: $condition) {
    id
    name
    translation
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductLabelMutationVariables,
  APITypes.DeleteProductLabelMutation
>;
export const createProductTextItem = /* GraphQL */ `mutation CreateProductTextItem(
  $input: CreateProductTextItemInput!
  $condition: ModelProductTextItemConditionInput
) {
  createProductTextItem(input: $input, condition: $condition) {
    id
    productId
    productTextId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductTextItemMutationVariables,
  APITypes.CreateProductTextItemMutation
>;
export const updateProductTextItem = /* GraphQL */ `mutation UpdateProductTextItem(
  $input: UpdateProductTextItemInput!
  $condition: ModelProductTextItemConditionInput
) {
  updateProductTextItem(input: $input, condition: $condition) {
    id
    productId
    productTextId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductTextItemMutationVariables,
  APITypes.UpdateProductTextItemMutation
>;
export const deleteProductTextItem = /* GraphQL */ `mutation DeleteProductTextItem(
  $input: DeleteProductTextItemInput!
  $condition: ModelProductTextItemConditionInput
) {
  deleteProductTextItem(input: $input, condition: $condition) {
    id
    productId
    productTextId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductTextItemMutationVariables,
  APITypes.DeleteProductTextItemMutation
>;
export const createProductText = /* GraphQL */ `mutation CreateProductText(
  $input: CreateProductTextInput!
  $condition: ModelProductTextConditionInput
) {
  createProductText(input: $input, condition: $condition) {
    id
    name
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductTextMutationVariables,
  APITypes.CreateProductTextMutation
>;
export const updateProductText = /* GraphQL */ `mutation UpdateProductText(
  $input: UpdateProductTextInput!
  $condition: ModelProductTextConditionInput
) {
  updateProductText(input: $input, condition: $condition) {
    id
    name
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductTextMutationVariables,
  APITypes.UpdateProductTextMutation
>;
export const deleteProductText = /* GraphQL */ `mutation DeleteProductText(
  $input: DeleteProductTextInput!
  $condition: ModelProductTextConditionInput
) {
  deleteProductText(input: $input, condition: $condition) {
    id
    name
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductTextMutationVariables,
  APITypes.DeleteProductTextMutation
>;
export const createProductMask = /* GraphQL */ `mutation CreateProductMask(
  $input: CreateProductMaskInput!
  $condition: ModelProductMaskConditionInput
) {
  createProductMask(input: $input, condition: $condition) {
    id
    name
    sku
    productId
    clientId
    filterColors
    mainImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    increment
    fee
    discount
    stock
    categoryId
    sellMode
    kitPieces
    kitIncrement
    kitFee
    stockMode
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductMaskMutationVariables,
  APITypes.CreateProductMaskMutation
>;
export const updateProductMask = /* GraphQL */ `mutation UpdateProductMask(
  $input: UpdateProductMaskInput!
  $condition: ModelProductMaskConditionInput
) {
  updateProductMask(input: $input, condition: $condition) {
    id
    name
    sku
    productId
    clientId
    filterColors
    mainImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    increment
    fee
    discount
    stock
    categoryId
    sellMode
    kitPieces
    kitIncrement
    kitFee
    stockMode
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductMaskMutationVariables,
  APITypes.UpdateProductMaskMutation
>;
export const deleteProductMask = /* GraphQL */ `mutation DeleteProductMask(
  $input: DeleteProductMaskInput!
  $condition: ModelProductMaskConditionInput
) {
  deleteProductMask(input: $input, condition: $condition) {
    id
    name
    sku
    productId
    clientId
    filterColors
    mainImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    increment
    fee
    discount
    stock
    categoryId
    sellMode
    kitPieces
    kitIncrement
    kitFee
    stockMode
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductMaskMutationVariables,
  APITypes.DeleteProductMaskMutation
>;
export const createVariantMask = /* GraphQL */ `mutation CreateVariantMask(
  $input: CreateVariantMaskInput!
  $condition: ModelVariantMaskConditionInput
) {
  createVariantMask(input: $input, condition: $condition) {
    id
    filterColors
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock
    stockMode
    productMaskId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVariantMaskMutationVariables,
  APITypes.CreateVariantMaskMutation
>;
export const updateVariantMask = /* GraphQL */ `mutation UpdateVariantMask(
  $input: UpdateVariantMaskInput!
  $condition: ModelVariantMaskConditionInput
) {
  updateVariantMask(input: $input, condition: $condition) {
    id
    filterColors
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock
    stockMode
    productMaskId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateVariantMaskMutationVariables,
  APITypes.UpdateVariantMaskMutation
>;
export const deleteVariantMask = /* GraphQL */ `mutation DeleteVariantMask(
  $input: DeleteVariantMaskInput!
  $condition: ModelVariantMaskConditionInput
) {
  deleteVariantMask(input: $input, condition: $condition) {
    id
    filterColors
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock
    stockMode
    productMaskId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteVariantMaskMutationVariables,
  APITypes.DeleteVariantMaskMutation
>;
export const createProductMaskDescription = /* GraphQL */ `mutation CreateProductMaskDescription(
  $input: CreateProductMaskDescriptionInput!
  $condition: ModelProductMaskDescriptionConditionInput
) {
  createProductMaskDescription(input: $input, condition: $condition) {
    id
    long_description
    short_description
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductMaskDescriptionMutationVariables,
  APITypes.CreateProductMaskDescriptionMutation
>;
export const updateProductMaskDescription = /* GraphQL */ `mutation UpdateProductMaskDescription(
  $input: UpdateProductMaskDescriptionInput!
  $condition: ModelProductMaskDescriptionConditionInput
) {
  updateProductMaskDescription(input: $input, condition: $condition) {
    id
    long_description
    short_description
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductMaskDescriptionMutationVariables,
  APITypes.UpdateProductMaskDescriptionMutation
>;
export const deleteProductMaskDescription = /* GraphQL */ `mutation DeleteProductMaskDescription(
  $input: DeleteProductMaskDescriptionInput!
  $condition: ModelProductMaskDescriptionConditionInput
) {
  deleteProductMaskDescription(input: $input, condition: $condition) {
    id
    long_description
    short_description
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductMaskDescriptionMutationVariables,
  APITypes.DeleteProductMaskDescriptionMutation
>;
export const createCoupon = /* GraphQL */ `mutation CreateCoupon(
  $input: CreateCouponInput!
  $condition: ModelCouponConditionInput
) {
  createCoupon(input: $input, condition: $condition) {
    id
    code
    name
    description
    discountAmount
    discountPercentage
    minAmount
    maxAmount
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    applicableProducts
    applicableCategories
    excludedProducts
    status
    createdBy
    redemptions {
      items {
        id
        couponId
        couponCode
        userId
        clientId
        orderId
        cartId
        discountApplied
        originalAmount
        finalAmount
        appliedAt
        ipAddress
        userAgent
        coupon {
          id
          code
          name
          description
          discountAmount
          discountPercentage
          minAmount
          maxAmount
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          applicableProducts
          applicableCategories
          excludedProducts
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCouponMutationVariables,
  APITypes.CreateCouponMutation
>;
export const updateCoupon = /* GraphQL */ `mutation UpdateCoupon(
  $input: UpdateCouponInput!
  $condition: ModelCouponConditionInput
) {
  updateCoupon(input: $input, condition: $condition) {
    id
    code
    name
    description
    discountAmount
    discountPercentage
    minAmount
    maxAmount
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    applicableProducts
    applicableCategories
    excludedProducts
    status
    createdBy
    redemptions {
      items {
        id
        couponId
        couponCode
        userId
        clientId
        orderId
        cartId
        discountApplied
        originalAmount
        finalAmount
        appliedAt
        ipAddress
        userAgent
        coupon {
          id
          code
          name
          description
          discountAmount
          discountPercentage
          minAmount
          maxAmount
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          applicableProducts
          applicableCategories
          excludedProducts
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCouponMutationVariables,
  APITypes.UpdateCouponMutation
>;
export const deleteCoupon = /* GraphQL */ `mutation DeleteCoupon(
  $input: DeleteCouponInput!
  $condition: ModelCouponConditionInput
) {
  deleteCoupon(input: $input, condition: $condition) {
    id
    code
    name
    description
    discountAmount
    discountPercentage
    minAmount
    maxAmount
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    applicableProducts
    applicableCategories
    excludedProducts
    status
    createdBy
    redemptions {
      items {
        id
        couponId
        couponCode
        userId
        clientId
        orderId
        cartId
        discountApplied
        originalAmount
        finalAmount
        appliedAt
        ipAddress
        userAgent
        coupon {
          id
          code
          name
          description
          discountAmount
          discountPercentage
          minAmount
          maxAmount
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          applicableProducts
          applicableCategories
          excludedProducts
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCouponMutationVariables,
  APITypes.DeleteCouponMutation
>;
export const createCouponRedemption = /* GraphQL */ `mutation CreateCouponRedemption(
  $input: CreateCouponRedemptionInput!
  $condition: ModelCouponRedemptionConditionInput
) {
  createCouponRedemption(input: $input, condition: $condition) {
    id
    couponId
    couponCode
    userId
    clientId
    orderId
    cartId
    discountApplied
    originalAmount
    finalAmount
    appliedAt
    ipAddress
    userAgent
    coupon {
      id
      code
      name
      description
      discountAmount
      discountPercentage
      minAmount
      maxAmount
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      applicableProducts
      applicableCategories
      excludedProducts
      status
      createdBy
      redemptions {
        items {
          id
          couponId
          couponCode
          userId
          clientId
          orderId
          cartId
          discountApplied
          originalAmount
          finalAmount
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCouponRedemptionMutationVariables,
  APITypes.CreateCouponRedemptionMutation
>;
export const updateCouponRedemption = /* GraphQL */ `mutation UpdateCouponRedemption(
  $input: UpdateCouponRedemptionInput!
  $condition: ModelCouponRedemptionConditionInput
) {
  updateCouponRedemption(input: $input, condition: $condition) {
    id
    couponId
    couponCode
    userId
    clientId
    orderId
    cartId
    discountApplied
    originalAmount
    finalAmount
    appliedAt
    ipAddress
    userAgent
    coupon {
      id
      code
      name
      description
      discountAmount
      discountPercentage
      minAmount
      maxAmount
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      applicableProducts
      applicableCategories
      excludedProducts
      status
      createdBy
      redemptions {
        items {
          id
          couponId
          couponCode
          userId
          clientId
          orderId
          cartId
          discountApplied
          originalAmount
          finalAmount
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCouponRedemptionMutationVariables,
  APITypes.UpdateCouponRedemptionMutation
>;
export const deleteCouponRedemption = /* GraphQL */ `mutation DeleteCouponRedemption(
  $input: DeleteCouponRedemptionInput!
  $condition: ModelCouponRedemptionConditionInput
) {
  deleteCouponRedemption(input: $input, condition: $condition) {
    id
    couponId
    couponCode
    userId
    clientId
    orderId
    cartId
    discountApplied
    originalAmount
    finalAmount
    appliedAt
    ipAddress
    userAgent
    coupon {
      id
      code
      name
      description
      discountAmount
      discountPercentage
      minAmount
      maxAmount
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      applicableProducts
      applicableCategories
      excludedProducts
      status
      createdBy
      redemptions {
        items {
          id
          couponId
          couponCode
          userId
          clientId
          orderId
          cartId
          discountApplied
          originalAmount
          finalAmount
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCouponRedemptionMutationVariables,
  APITypes.DeleteCouponRedemptionMutation
>;
export const createPromotion = /* GraphQL */ `mutation CreatePromotion(
  $input: CreatePromotionInput!
  $condition: ModelPromotionConditionInput
) {
  createPromotion(input: $input, condition: $condition) {
    id
    name
    description
    triggerProductIds
    minQuantity
    triggerRule
    giftProductId
    giftQuantity
    isStackable
    applicableClientIds
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    status
    createdBy
    redemptions {
      items {
        id
        promotionId
        userId
        clientId
        orderId
        cartId
        triggerQuantity
        giftQuantityApplied
        appliedAt
        ipAddress
        userAgent
        promotion {
          id
          name
          description
          triggerProductIds
          minQuantity
          triggerRule
          giftProductId
          giftQuantity
          isStackable
          applicableClientIds
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePromotionMutationVariables,
  APITypes.CreatePromotionMutation
>;
export const updatePromotion = /* GraphQL */ `mutation UpdatePromotion(
  $input: UpdatePromotionInput!
  $condition: ModelPromotionConditionInput
) {
  updatePromotion(input: $input, condition: $condition) {
    id
    name
    description
    triggerProductIds
    minQuantity
    triggerRule
    giftProductId
    giftQuantity
    isStackable
    applicableClientIds
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    status
    createdBy
    redemptions {
      items {
        id
        promotionId
        userId
        clientId
        orderId
        cartId
        triggerQuantity
        giftQuantityApplied
        appliedAt
        ipAddress
        userAgent
        promotion {
          id
          name
          description
          triggerProductIds
          minQuantity
          triggerRule
          giftProductId
          giftQuantity
          isStackable
          applicableClientIds
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePromotionMutationVariables,
  APITypes.UpdatePromotionMutation
>;
export const deletePromotion = /* GraphQL */ `mutation DeletePromotion(
  $input: DeletePromotionInput!
  $condition: ModelPromotionConditionInput
) {
  deletePromotion(input: $input, condition: $condition) {
    id
    name
    description
    triggerProductIds
    minQuantity
    triggerRule
    giftProductId
    giftQuantity
    isStackable
    applicableClientIds
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    status
    createdBy
    redemptions {
      items {
        id
        promotionId
        userId
        clientId
        orderId
        cartId
        triggerQuantity
        giftQuantityApplied
        appliedAt
        ipAddress
        userAgent
        promotion {
          id
          name
          description
          triggerProductIds
          minQuantity
          triggerRule
          giftProductId
          giftQuantity
          isStackable
          applicableClientIds
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePromotionMutationVariables,
  APITypes.DeletePromotionMutation
>;
export const createPromotionRedemption = /* GraphQL */ `mutation CreatePromotionRedemption(
  $input: CreatePromotionRedemptionInput!
  $condition: ModelPromotionRedemptionConditionInput
) {
  createPromotionRedemption(input: $input, condition: $condition) {
    id
    promotionId
    userId
    clientId
    orderId
    cartId
    triggerQuantity
    giftQuantityApplied
    appliedAt
    ipAddress
    userAgent
    promotion {
      id
      name
      description
      triggerProductIds
      minQuantity
      triggerRule
      giftProductId
      giftQuantity
      isStackable
      applicableClientIds
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      status
      createdBy
      redemptions {
        items {
          id
          promotionId
          userId
          clientId
          orderId
          cartId
          triggerQuantity
          giftQuantityApplied
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePromotionRedemptionMutationVariables,
  APITypes.CreatePromotionRedemptionMutation
>;
export const updatePromotionRedemption = /* GraphQL */ `mutation UpdatePromotionRedemption(
  $input: UpdatePromotionRedemptionInput!
  $condition: ModelPromotionRedemptionConditionInput
) {
  updatePromotionRedemption(input: $input, condition: $condition) {
    id
    promotionId
    userId
    clientId
    orderId
    cartId
    triggerQuantity
    giftQuantityApplied
    appliedAt
    ipAddress
    userAgent
    promotion {
      id
      name
      description
      triggerProductIds
      minQuantity
      triggerRule
      giftProductId
      giftQuantity
      isStackable
      applicableClientIds
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      status
      createdBy
      redemptions {
        items {
          id
          promotionId
          userId
          clientId
          orderId
          cartId
          triggerQuantity
          giftQuantityApplied
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePromotionRedemptionMutationVariables,
  APITypes.UpdatePromotionRedemptionMutation
>;
export const deletePromotionRedemption = /* GraphQL */ `mutation DeletePromotionRedemption(
  $input: DeletePromotionRedemptionInput!
  $condition: ModelPromotionRedemptionConditionInput
) {
  deletePromotionRedemption(input: $input, condition: $condition) {
    id
    promotionId
    userId
    clientId
    orderId
    cartId
    triggerQuantity
    giftQuantityApplied
    appliedAt
    ipAddress
    userAgent
    promotion {
      id
      name
      description
      triggerProductIds
      minQuantity
      triggerRule
      giftProductId
      giftQuantity
      isStackable
      applicableClientIds
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      status
      createdBy
      redemptions {
        items {
          id
          promotionId
          userId
          clientId
          orderId
          cartId
          triggerQuantity
          giftQuantityApplied
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePromotionRedemptionMutationVariables,
  APITypes.DeletePromotionRedemptionMutation
>;
export const createWalletBalance = /* GraphQL */ `mutation CreateWalletBalance(
  $input: CreateWalletBalanceInput!
  $condition: ModelWalletBalanceConditionInput
) {
  createWalletBalance(input: $input, condition: $condition) {
    id
    balance
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWalletBalanceMutationVariables,
  APITypes.CreateWalletBalanceMutation
>;
export const updateWalletBalance = /* GraphQL */ `mutation UpdateWalletBalance(
  $input: UpdateWalletBalanceInput!
  $condition: ModelWalletBalanceConditionInput
) {
  updateWalletBalance(input: $input, condition: $condition) {
    id
    balance
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWalletBalanceMutationVariables,
  APITypes.UpdateWalletBalanceMutation
>;
export const deleteWalletBalance = /* GraphQL */ `mutation DeleteWalletBalance(
  $input: DeleteWalletBalanceInput!
  $condition: ModelWalletBalanceConditionInput
) {
  deleteWalletBalance(input: $input, condition: $condition) {
    id
    balance
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWalletBalanceMutationVariables,
  APITypes.DeleteWalletBalanceMutation
>;
export const createWalletMovement = /* GraphQL */ `mutation CreateWalletMovement(
  $input: CreateWalletMovementInput!
  $condition: ModelWalletMovementConditionInput
) {
  createWalletMovement(input: $input, condition: $condition) {
    id
    userId
    type
    amount
    orderId
    createdByUserId
    couponId
    couponCode
    availableUntil
    isValidated
    validatedAt
    validatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWalletMovementMutationVariables,
  APITypes.CreateWalletMovementMutation
>;
export const updateWalletMovement = /* GraphQL */ `mutation UpdateWalletMovement(
  $input: UpdateWalletMovementInput!
  $condition: ModelWalletMovementConditionInput
) {
  updateWalletMovement(input: $input, condition: $condition) {
    id
    userId
    type
    amount
    orderId
    createdByUserId
    couponId
    couponCode
    availableUntil
    isValidated
    validatedAt
    validatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWalletMovementMutationVariables,
  APITypes.UpdateWalletMovementMutation
>;
export const deleteWalletMovement = /* GraphQL */ `mutation DeleteWalletMovement(
  $input: DeleteWalletMovementInput!
  $condition: ModelWalletMovementConditionInput
) {
  deleteWalletMovement(input: $input, condition: $condition) {
    id
    userId
    type
    amount
    orderId
    createdByUserId
    couponId
    couponCode
    availableUntil
    isValidated
    validatedAt
    validatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWalletMovementMutationVariables,
  APITypes.DeleteWalletMovementMutation
>;
